import { Component, OnInit, Input, Output, ChangeDetectorRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, UntypedFormBuilder, Validators, FormGroup } from '@angular/forms';
import { DhlFormTemplate } from '../../models/dhl-form-template';
import { FormService } from '../../services/form.service';
import { Router,ActivatedRoute } from '@angular/router';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { EventEmitter } from '@angular/core';
import { ModalService } from 'src/app/common/modal/modal.service';
import { APP_Constants } from 'src/app/app.constant';
import { AppService } from 'src/app/app.service';
import { SnackBarComponent } from 'src/app/common/snack-bar/snack-bar.component';
import { Modal } from 'src/app/common/modal/modal';
import { Subscription } from 'rxjs';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import {TranslateService} from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import { Constant } from 'src/app/shared/constants/constants';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service'
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';




@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormComponent implements OnInit, AfterViewInit, OnDestroy {
  // DHL FORM TEMPLATE TO BE PROVIDED IN THE COMPONENT BY PARENT AFTER LOADED FROM BACKEND
  @Input() configData;    //DhlFormTemplate configure it properly
  @Input() expanded: any
  // @Input() orderView;
  @Input() orderDetails;
  @Input() searchMessage;
  @Input() searchDataLength;
  @Input() screenVersion;
  @Input() multipleOrderDetails;
  @Output() form = new EventEmitter();
  @Output() formStatus = new EventEmitter();
  @Output() loadingStatus = new EventEmitter();
  @Output() navToIndexEmitter = new EventEmitter();

  frmGroup: UntypedFormGroup;
  isLoading: boolean = false;
  formFieldFrmGroup:UntypedFormGroup;
  selfServiceConfig : boolean = false;
  orderFormSubmitted: any;
  orderForm: any;
  color: String = 'primary';
  mode: String = 'indeterminate';
  pageName: String;
  orderViewTemplate;
  durationInSeconds = 20;
  turnOnAction: boolean = true;
  orderDtls;
  headerDetails:any;
  subform: boolean = false;
  formName: String = "";
  releaseOrdercall:boolean =false;
  includeStatuscall: boolean = false;
  stepperSameRow: boolean = true;
  bannerArrayViewList : any =  ['releaseOrder', 'orderEntry'];
  arrayOfTempName = ['releaseOrder', 'orderEntry', 'orderViewEdit', 'releaseOrderViewEdit'];
  ellipseBtn = {
    "showDrop": false
  }

  subscription: Subscription;
  totalError : any = 0;
  constant : any = Constant;
  stopTimeout$ : any;
  ArrayOfFilledFields : any = [];
  isDarftGetError : any = false;
  timeout:any;
  
  isSelectAllCount: any;
  orderStatusValidation : any = false;
  templatedata :any;
  editField: boolean;
  templateData: any;
  flagAdd: boolean;
  lableForConfig: any;
  columnOptions: any;
  columnOrder: boolean;
  rearrangeColumns: any;
  enableFinalStepAction: boolean = false;
  enableFinalStepAction$: Subscription;
  infoFieldsToDisplay: any[] = [];
  trackingLinkField: any = null;
  subHearderInfo: any;
  isSubHeaderVisible: boolean = false;
  badgeText: string;
  badgeClassName: string;
  badgeStatus: string;
  isEllipsisHidden: boolean = false;
  documentUploadIds: string[] = [];
  // tempData;
  // fillData(){
  //   this.frmGroup.controls.stepOne.patchValue(this.tempData.orderDetails[0].stepOne)
  //   this.frmGroup.controls.stepTwo.patchValue(this.tempData.orderDetails[1].stepTwo)
  // }

  constructor(private modalService: ModalService, private _snackBar: CustomSnackBarService, private fb: UntypedFormBuilder, private change: ChangeDetectorRef, private formService: FormService, private router: Router, private appService: AppService,private route: ActivatedRoute, public translate: TranslateService, private alphaService : AlphaService) {
    // don't forget to comment this button
    // this.tempData = {"orderDetails": [{"stepOne":[{"orderCreatedDate":"11/11/2020","orderDetails[orderReferenceId]":"1234","":"1234","space1":"","salesChannel":"channel1","quoteId":"","agent":"","externalOrderReference":"","sourceCustomer":"","buyerId":"","cmNumber":"","clientName":"1234","clientAddress1":"","clientCity":"","clientSpace1":"","clientSpace2":"","clientAddress2":"","clientZip":"","payerName":"","payerSpace1":"","payerSpace2":"","payerZip":""}]},{"stepTwo":[{"vin":"1234","originContactName":"","origLocationName":"","originAddress1":"134","originCity":"122","originSpace1":"","originSpace2":"","originAddress2":"","originState":{"value":"AK","displayValue":"AK","selected":true},"originZip":"123","destContactName":"","destLocationName":"","destAddress1":"12","destCity":"eedd","destSpace1":"","destSpace2":"","destAddress2":"","destState":{"value":"AL","displayValue":"AL","selected":true},"destZip":"122","odMiles":""}]},{"stepThree":[{"estimatedPickupDate":"122","estimatedDeliveryDate":"$CURR122ENT_DATE","step3Space1":"","docSupplied":"","step3Space2":"","step3Space3":"","step3Space4":"","enclosedRequired":"","isOperable":"","isRepo":"","step3Space5":"","specialInstructions":"1233","vehicleNotes":"1234","dispatchNotes":"1234","predispatchNotes":"123","isCancelled":"","isRejected":"","isHold":true,"clientPurchaseOrder":"","itemReference":"","pricefxQuoteId":""}]}]};
    // this.tempData = {"orderDetails":[{"stepOne":[{"orderCreatedDate":"date","orderReferenceId":"idnumber","partnerId":"pidno","space1":"","salesChannel":"channel","quoteId":"","agent":"","externalOrderReference":"","sourceCustomer":"","buyerId":"","cmNumber":"","clientName":"cname","clientAddress1":"","clientCity":"","clientSpace1":"","clientSpace2":"","clientAddress2":"","clientZip":"","payerName":"","payerSpace1":"","payerSpace2":"","payerZip":""}]},{"stepTwo":[{"vin":"vinno","originContactName":"","origLocationName":"","originAddress1":"org add1","originCity":"orgcity","originSpace1":"","originSpace2":"","originAddress2":"","originState":"AK","originZip":"orgzip","destContactName":"","destLocationName":"","destAddress1":"desadd","destCity":"descity","destSpace1":"","destSpace2":"","destAddress2":"","destState":"AS","destZip":"deszip","odMiles":""}]},{"stepThree":[{"estimatedPickupDate":"datepickup","estimatedDeliveryDate":"datedelivery","step3Space1":"","docSupplied":"","step3Space2":"","step3Space3":"","step3Space4":"","enclosedRequired":"","isOperable":"","isRepo":"","step3Space5":"","specialInstructions":"req 1 ","vehicleNotes":"note 1","dispatchNotes":"d notes","predispatchNotes":"p d note","isCancelled":"","isRejected":"","isHold":true,"holdReleaseDate":"releasedate","holdReason":"2","clientPurchaseOrder":"","itemReference":"","pricefxQuoteId":""}]}]}
    // don't forget to comment this button
  }

  setFormMetadata(data) {
    this.orderViewTemplate = data;
  }
  isEnclosed:string;
  tradeIn_isEnclosed:string;
  isOparable:string;
  tradeIn_isOparable:string;
  hideSection: boolean = true;
  hideField: boolean = true;
  rateCustom: boolean = false;

  ngOnInit() {
    this.appService.formConfigData = this.configData;
    if (this.configData?.header?.stepper?.labels?.some(data => data?.enableFinalStepAction)) {
      this.appService.enableFinalStepAction$.subscribe(value => {
        this.enableFinalStepAction = !value;
      });
    }
        
        if (this.configData?.header?.action?.controls) {
          this.formFieldFrmGroup = this.formService.createForm({
            controls: this.configData.header.action.controls
          });
        }        
        
    console.log('form.component.ts :: ngoninit', 'on start', new Date())
    // update group message start
    this.orderDtls = this.orderDetails;
    //CP-9499 start
    let shimpemtDetails=[];
    if(this.orderDtls){
      if (this.configData.header?.headerInfo)
      {
        if (this.orderDtls.rawData.shipments_Details && this.orderDtls.rawData.shipments_Details.length > 0) {
        this.orderDtls.rawData.shipments_Details.forEach(shimnt=>{
          shimpemtDetails.push({"shipmentID":shimnt.shipmentId,"loadID":shimnt.shipmentDetails_loadId});
        })
      }
      this.headerDetails = {
        "Year": this.orderDtls.rawData.vehicleDetails_vehicleYear,
        "Make": this.orderDtls.rawData.vehicleDetails_vehicleMake,
        "Model": this.orderDtls.rawData.vehicleDetails_vehicleModel,
        "Vin": this.orderDtls.rawData.vehicleDetails_vin,
        "Status":this.orderDtls.rawData.status,
        "ShipmentIds":shimpemtDetails,
        "orderNumber": this.orderDtls.rawData.businessObjectNumber
      }
      this.stepperSameRow = false;
      }
    }
    //CP-9499 end

    if(this.configData.hasOwnProperty("name")){
      this.formName = this.configData.name;
    }
    if(this.configData.hasOwnProperty("header") && this.configData.header.hasOwnProperty("action") && this.configData.header.action.hasOwnProperty("enable")){
      this.turnOnAction = this.configData.header.action.enable;
    }
    if (this.configData && this.orderDtls && this.configData.hasOwnProperty("checkEnrichment") && this.configData.checkEnrichment === true) {
      //CP-9456-start if function called based on template contains section/groups
      if(this.configData.hasOwnProperty("sections")) {
        this.configData.sections.forEach(section => {
          this.showEnrichmentMessage(section);
        });
      } 
      else if(this.configData.hasOwnProperty("groups")) {
        this.showEnrichmentMessage(this.configData);
      }
      //CP-9456-end
    }
    // update group message end
    if (this.configData.customFormFlag) {
      this.selfServiceConfig = false;
    }
    else if (sessionStorage.getItem('isSelfServiceConfig')) {
      this.selfServiceConfig = true;
    }
    console.log("order details", this.orderDetails);


    this.formStatus.emit(this.isSubmitted);
    localStorage.setItem('lastShipCard', 'false');

    localStorage.setItem('templateName', this.configData.name);
    this.pageName = APP_Constants.SEARCH_PAGE;
    console.log('form.component.ts :: ngoninit', 'before create form', new Date())
    if(this.configData['schemaValidation']){
      this.frmGroup = this.formService.simpleFormCreation(this.configData);
    } else{
      this.frmGroup = this.formService.createForm(this.configData);
    }

    if(this.configData.name === 'selfConfig_BE_ParentXML'){
      this.frmGroup.patchValue(this.orderDetails);
    }
    this.subform = this.frmGroup['subform'] || false;
    console.log(this.frmGroup);
    let obj = this.orderDetails;

    if ((obj !== null && obj !== undefined && obj.value !== undefined && obj.value !== null) || (obj !== null && obj !== undefined && obj.data !== undefined && obj.data !== null && obj.data.businessObject)) {
      if(this.configData.name !== "rateEnquirySearch"){
        this.frmGroup = this.formService.createOrderFormToViewAndEdit(this.frmGroup, this.configData, obj);
        if(!obj.skipSecondary || obj.skipSecondary === undefined){
          console.log('form.component.ts :: ngoninit', 'before set sec text', new Date())
          if (this.isStepperUsed()) {
            // Find the step formgroup name, which has "origin" field
            const originStep = Object.keys(this.frmGroup.controls).find((cName) => {
              const formArray = (this.frmGroup.get(cName) as UntypedFormArray);
              return formArray.length > 0 && formArray.at(0).get("origin");
            });
            if(originStep){
              let data = {...obj};
              if(data.hasOwnProperty('originalData')){
                data = {...data, ...data.originalData};
              }
              this.formService.setSecondaryTextFormField(data, (this.frmGroup.get(originStep) as UntypedFormArray).at(0));
            }
          } else {
            this.formService.setSecondaryTextFormField(obj, this.frmGroup);
          }
          console.log('form.component.ts :: ngoninit', 'after set sec text', new Date())
        }
        if (obj.status && !(obj.status.toUpperCase() === 'CREATED' || obj.status.toUpperCase() === 'SHIP_NOT_CONFIRMED' || obj.status.toUpperCase() === 'ITN_NOT_ENTERED')) {
          this.turnOnAction = false;
          setTimeout(() => {
            //this.frmGroup.disable();
            if(this.configData.cloneFeature == undefined){
              this.frmGroup.disable();
            }
            if (this.configData.cloneFeature && this.configData.cloneFeature.enable == true) {
              this.frmGroup.enable();
            }
          }, 800);
        }
        if(this.configData.groups){
          this.configData.groups.map((data) => {
            data.open = false;
          });
          this.dynamicVisibilityofGrpsAndCntrls();
          let enableStagingSection=false;
          if(this.orderDtls && this.orderDtls["rawData"]){
            enableStagingSection = this.orderDtls["rawData"]?.orderDetails_distanceFromOrigination;
            if (!enableStagingSection || enableStagingSection === undefined) {
              this.showGroup(false)
            }
          }
        }
    
        if(this.configData.dataLoadFormat=="stepper"){
         // this.turnOnAction = false;
          setTimeout(()=>{
         //   this.formService.setSecondaryStepperTextFormField(obj, this.frmGroup,this.configData.locationSecondary);
          }, 800)
        }
      }
    console.log('form.component.ts :: before path', 'on start', new Date())
      if (this?.configData?.payloadFormat === 'DYNAMIC_ACCORDION') {
        if(localStorage.getItem('filterCurrenturl')?.includes('draft')) {
          this.formService.patchingValueForViewEdit(this.frmGroup, this.configData, obj.value);
        } else {
          this.formService.patchingValueForViewEdit(this.frmGroup, this.configData, obj.data.businessObject);
        }
      } else {
        this.frmGroup.patchValue(obj.value);
      }
      setTimeout(()=>{
        // this.frmGroup.patchValue(obj.value);
      }, 200)
      if(obj.validateField){
        this.validateAllFormFields(this.frmGroup);
      }
    }
    this.form.emit(this.frmGroup);
    if (this.configData.screenVersion && this.configData.screenVersion === 'v2') {
      if (this.configData?.header?.stepper?.position && this.configData?.header?.stepper?.position == 'nextrow') {
        this.stepperSameRow = false;
      }
    }
    if (this.configData.header?.single_order_create_screen) {
      this.stepperSameRow = false;
  }
  if(sessionStorage.getItem('isRefineSearch') === 'true'){
   this.checkValue(this.frmGroup);
  }
    this.poSelected()
  if (this.configData.name === 'rateEnquirySearch') this.rateCustom = true;

  this.alphaService.mapConfigDataControls(this.configData);

  this.alphaService.executeGroupValidations({
    validations: this.configData.groupValidations,
    formGroup: this.frmGroup,
    shouldValidate: false,
    shouldSubscribe: true,
  });
  this.appService.groupValidationSubscription$.subscribe(() => {
    this.alphaService.executeGroupValidations({
      validations: this.configData.groupValidations,
      formGroup: this.frmGroup,
      shouldValidate: false,
      shouldSubscribe: true,
    });
  });
  
  if(this.configData?.payloadFormat == 'DYNAMIC_ACCORDION') {
    if(this.configData?.header?.subHeaderInfo?.shipmentDetails) this.getSubHeaderInfo(this.orderDetails);
    if(this.configData?.editAccessRules) this.alphaService.checkEditAccessRules(this.frmGroup, this.configData);
  }

  if(this.configData?.header?.action?.ellipse) {
    const ellipses = this.configData.header.action.ellipse;

    ellipses?.forEach(data => {
      if (data?.actions) {
        this.checkEllipsisAccess(data.actions);
      }
      if (!data?.hidden) {
        data.hidden = this.isEllipsisHidden;
      }
    });
  }
}

  checkValue(formGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      if (field === 'destinationWrapper' || field === 'sourceWrapper') {
        const control = formGroup.get(field);
        control.controls.forEach(ele => {
          Object.keys(ele.controls).forEach(element=>{
            const control= ele.get(element);
              if(control.value){
                control.markAsDirty();
                control.markAsTouched();
                return;
              }
            })
        })
      }
    })
  }
  
  poSelected(){
    this.isSelectAllCount = localStorage.getItem('TotalPoLinesSelected');
    if(this.isSelectAllCount === ''|| Number.isNaN(this.isSelectAllCount) || this.isSelectAllCount === null){
    
      this.isSelectAllCount = 0;
      localStorage.setItem('TotalPoLinesSelected',this.isSelectAllCount);
    }else{
      return this.isSelectAllCount;
    }
   console.log("isSelectAllCount",this.isSelectAllCount)  
    
    
  }

  editFieldConfig(sCancel, label, grouplabel) {

    if (label === 'maintitle') {
      if (this.configData !== null) {
        this.editField = true;
        this.lableForConfig = label;
        this.appService.setOrderTemplate(this.configData);
        this.templateData = this.configData
      }
    }
    else if (label === 'bannerMsg') {
      this.editField = true;
      this.lableForConfig = label;
      this.appService.setOrderTemplate(this.configData?.bannerDetails?.bannerMessage);
      this.templateData = this.configData?.bannerDetails?.bannerMessage
    }
    else if (this.configData.sections) {
      this.configData.sections.forEach(section => {
        if (section.label == label) {
          this.editField = true;
          if (this.configData !== null) {
            this.appService.setOrderTemplate(section);
            this.templateData = section
          }
        }
      })
    }
    else if (label === 'addField') {
      this.editField = true;
      this.lableForConfig = label + "-" + grouplabel;
      this.configData.groups.forEach((elm, idx) => {
        this.appService.setOrderTemplate(elm.controls[0]);
        this.templateData = elm.controls[0]
      })
    } else if (label == 'updateField') {
      this.editField = true;
      if (this.configData !== null) {
        this.appService.setOrderTemplate(grouplabel);
        this.templateData = grouplabel
      }
    }
    else {
      if(this.configData?.groups){
          this.configData?.groups.forEach(group => {
            if (group.label == label) {
              this.editField = true;
              if (this.configData !== null) {
                this.appService.setOrderTemplate(group);
                this.templateData = group
              }
            }
          })
      }
    }


    if (sCancel == 'cancel') {
      this.editField = false;
    }
  }

  removeFields(e,ctrl,id,crlIdx){
    if(sessionStorage.getItem("parentTemplate"))
      {
        let parentTemplate = JSON.parse(sessionStorage.getItem("parentTemplate"));
        parentTemplate.groups.forEach((elm, idx) => {
          if(id===idx){
          if (crlIdx !== -1) {
            parentTemplate.groups[idx].controls.splice(crlIdx, 1);
        } 
      }   
      })
      localStorage.setItem("parentTemplate",JSON.stringify(parentTemplate));
      console.log("UPDATED_TEMPLATE",parentTemplate);
      this.templatedata = JSON.parse(localStorage.getItem('templatedata'));
      let url
      console.log("res---------------",this.templatedata);
      if(localStorage.getItem('filterCurrenturl')=='/selfServiceListing/selfconfigdraft')
      {
        url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
      }
         else {
          url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
        +'&listingType='+"UIListing"
    }
  
      console.log("url--------",url,parentTemplate)
      this.appService.makeHttpPostRequest(url,parentTemplate).subscribe((data) => {
        if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          this.formError = ''
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
         // this.normalView();
          let preferenceId = data['data'].preferenceId;
          let saveDraftMsg = `Draft created`;
          let tempdata =  JSON.parse(localStorage.getItem('templatedata'))
          this.router.navigateByUrl('/selfServiceListing/'+tempdata.customer_id+ "-"+tempdata.action);
          window.location.reload()

          console.log("data----------",data)
         this._snackBar.open({ message: data['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
        }
      }, err => {
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
       // this.normalView();

        let modal = new Modal({
          action: false, name: 'Updated', title: 'Update Json ', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
      }
  }
  

  getFormStatus(e) {
    this.orderFormSubmitted = e;
  }
  getForm(e) {
    this.orderForm = e;
  }

  drop(event: CdkDragDrop<string[]>,label) {
    this.configData.groups.forEach((elm, idx) => {
    if(label==elm.label){
    moveItemInArray(elm.controls, event.previousIndex, event.currentIndex);
    }
    })
  }

  // [CP-8488] Standard quotation request should not have staging location section - Jira DHL
  showGroup(visibility) {
    this.configData.groups.forEach((group) => {
      if (group.visibility === true) {
        this.toggleVisibility(visibility, group.name);
      }
    });
  }

  // show/hide group with controls based on some other field action 
  toggleVisibility(hidden, groupname) {
    this.configData.groups.forEach(group => {
      if (group.name === groupname) {
        group['visibility'] = hidden;
        group.controls.forEach(control => {
          if (this.appService._components[control.name] && this.appService._components[control.name].toggleVisibility)
            this.appService._components[control.name].toggleVisibility(!hidden);
        })
      }
    });
    //this.changeDetector.detectChanges();
  }
  
  dynamicVisibilityofGrpsAndCntrls() {
    this.configData?.groups?.forEach(element => {
      if (element.controls) {
        element.controls.forEach(field => {
          if (element['dynamicVisibility']) {
            if (element['dynamicVisibility'].action == 'hidden') {
              this.hideSection = this.checkAccess(element['dynamicVisibility'].featureName);
              if (!this.hideSection) {
                element['label'] = '';
                element['showDividerLine'] = false;
                element['visibility'] = false;
                this.frmGroup.removeControl(field.name);
              }
            }
          }
          else if (field['dynamicVisibility']) {
            if (field['dynamicVisibility'].action == 'hidden') {
              this.hideField = this.checkAccess(field['dynamicVisibility'].featureName);
              if (!this.hideField) {
                field['cols'] = [];
              }
            }
          }
        });
      }
    });

  }

  //CP-9456-start
  showEnrichmentMessage(data){
    data["groups"].forEach(group => {
      if (this.orderDtls && this.orderDtls.hasOwnProperty("rawData")) {
        let msg ='';
        let groupEnrichmentNames = group.groupEnrichmentName ? group.groupEnrichmentName.split('-') : '';
        let groupEnrichmentMessage = group.groupEnrichmentMessage ? group.groupEnrichmentMessage.split('_') : '';
       
        for (let substatus in this.orderDtls["rawData"]) {
          if (substatus.includes('substatus')) {
            let i=0;
            if(groupEnrichmentNames.length > 0 && groupEnrichmentMessage.length > 0){
            groupEnrichmentNames.forEach(name => {
              if (name === substatus && this.orderDtls["rawData"][substatus] === false) {
                group.showGroupEnrichmentMessage = group.showGroupEnrichmentMessage !== null ? true : null;
                if (groupEnrichmentNames.length > 0) { // (i === 0)
                  if (name === 'substatus_pickupNamePhoneEnrichmentEnriched') {
                    groupEnrichmentMessage[i] = groupEnrichmentMessage[i].replace('CAIXXXXX', this.orderDtls["rawData"].originDetails_locationId);
                  } else if (name === 'substatus_dropoffNamePhoneEnrichmentEnriched') {
                    groupEnrichmentMessage[i] = groupEnrichmentMessage[i].replace('CAIXXXXX', this.orderDtls["rawData"].destinationDetails_locationId);
                  } else if (name === 'substatus_PayerEnriched' || name === 'substatus_ClientEnriched') {
                    groupEnrichmentMessage[i] = this.orderDtls["rawData"].clientDetails_buyerId ? groupEnrichmentMessage[i] + " ( buyerID = " + this.orderDtls["rawData"].clientDetails_buyerId + " )" : groupEnrichmentMessage[i]; //CP-7078
                  }
                  let errorText = groupEnrichmentMessage[i];
                    if(groupEnrichmentNames && groupEnrichmentNames.length > 0){
                      let backendErrorMessageKey = groupEnrichmentNames[i].replace('substatus','errorMessage');
                      if(backendErrorMessageKey && this.orderDtls["rawData"][backendErrorMessageKey]){
                        errorText = this.orderDtls["rawData"][backendErrorMessageKey];
                      }
                    }
                  msg += '<div>' + errorText + '</div>';
                }
              }
              i++;
            });
            group.groupEnrichmentMessage = msg;
          }
          }
        }
      }
      //CP-7925-start : On hold section in the order update screen is inactive for escalated to client orders
      let groupDisable = false; // For now, functionality is implemented for Disabling section, based on roleAccess, and parameter value coming from backend. But it can be extended to different features as well like Hidden
        if (group.events) {
            group.events.forEach(ev => {
                if (ev.event === "DISABLED" && ev.props) {
                    ev.props.forEach(prop => {
                        if (prop.action === "DISABLED") {
                          if (prop.name && prop[prop.name] && Array.isArray(prop[prop.name]) 
                          && prop[prop.name].includes(this.orderDtls["rawData"][prop.name]) // Checking parameter value from backend with value given in template
                          && prop.roleAccess && Array.isArray(prop.roleAccess) && prop.roleAccess.includes(localStorage.userRole) // Checking userRole with Template values
                            ) {
                                groupDisable = true;
                            }
                        }
                    })
                }
            })
        }
        if (groupDisable) {
          group.controls.forEach(control => {
              control.disabled = true;
          })
        } // CP-7925-end
    });
  }
  //CP-9456-end

  isStepperUsed(){
    return this.configData.hasOwnProperty("sections") &&
    Array.isArray(this.configData.sections) &&
    this.configData.sections.length > 0 &&
    this.configData.sections[0].hasOwnProperty("component") &&
    this.configData.sections[0].component == 'STEPPER'
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }

  //CP-8121 - start
  checkSectionAccess(group, index) {
    if (group.editAccess) {
      group.editAccess.forEach(row => {
        let persona;
        if (row.roleAccess) {
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }        
        if (index && this.configData.groups[index - 1].visibility === false) {//if previous section is also hidden
          this.configData.groups[index - 1].visibility;
          group.showDividerLine = false;
        }
        else {
          group.showDividerLine = true;
        }
        if (row.action == 'hidden' && !this.checkFieldAccess(persona)) {
          group.visibility = false;
          return false;
        }
      });
      return true;
    }
    if(index && this.configData.groups[index - 1].visibility === false && this.configData.groups[index].showDividerLine === true){
      group.showDividerLine = true;
    } else if (index && this.configData.groups[index - 1].visibility === false) {//if previous section is also hidden
      this.configData.groups[index - 1].visibility;
      group.showDividerLine = false;
    }
    else {
      group.showDividerLine = true;
    }
    return true;
  }


  checkHeaderAccess(data, index) {
    if (data.editAccess) {
      data.editAccess.forEach(row => {
        let persona;
        if (row.roleAccess) {
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }        
        if (row.action == 'hidden' && !this.checkFieldAccess(persona)) {
          data.visibility = false;
          return false;
        }
      });
    }
    return true;
  }

  // Method to check if the logged in user is having access of mentioned persona
  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }
  //CP-8121 - end


  ngAfterViewInit() {
    if(this.configData.hasOwnProperty('header') && this.configData['header'].hasOwnProperty('action') && this.configData['header']['action'].hasOwnProperty('details')){
      this.configData['header']['action']['details'].forEach(action => {
        action['enableAction'] = action["enableActionOnLastStep"] ? !action["enableActionOnLastStep"] : true;
      });
    }
    if (this.configData.header?.single_order_create_screen) {
      this.configData.header.action.details[1].enableAction = true;
    }
    //persona to hide VIP from ellipse
    if(this.configData.hasOwnProperty('header') && this.configData['header'].hasOwnProperty('action') && this.configData['header']['action'].hasOwnProperty('ellipse')){
      this.configData['header']['action']['ellipse'].forEach(action => {
        action.actions.forEach(ele => {
          if (ele['dynamicVisibility']) {
            if(ele['dynamicVisibility'].action == 'hidden'){
              ele['hidden'] = !this.checkAccess(ele['dynamicVisibility'].featureName);
            }else if(ele['dynamicVisibility'].action == 'disabled'){
              if(this.checkAccess(ele['dynamicVisibility'].featureName) == false){
                ele['disabled'] = true;
              }
            }
          }
        });
      });
    }

    this.subscription = this.appService._stepperContentSubject.subscribe(res => {
      if(res && res.hasOwnProperty("stepIndex") && res.hasOwnProperty("stepperDetails")){
        if(this.configData.hasOwnProperty('header') && this.configData['header'].hasOwnProperty('action') && this.configData['header']['action'].hasOwnProperty('details')){
          this.configData["header"]["action"]["details"].forEach(action => {
            if(action.hasOwnProperty('enableActionOnLastStep') && action.enableActionOnLastStep && (res['stepIndex'] == res['stepperDetails'].length-1)) {
              action.enableAction = true;
            }
          });
        }
      }
    });
    if (!this.stepperSameRow) {
      if (document.getElementById('dhlFormContentV2'))
        document.getElementById('dhlFormContentV2').style.marginTop = '160px';
    }

    if((this.configData?.name == 'orderViewEdit' || this.configData?.name == 'releaseOrderViewEdit') && (this.orderDetails?.status?.toLowerCase() === 'confirmed' || this.orderDetails?.status?.toLowerCase() === 'planned'|| this.orderDetails?.status?.toLowerCase() === 'ship_confirmed')){
      this.orderStatusValidation = true;
    } else {
      this.orderStatusValidation = false;
    }

    this.poSelected()
  }

  setAccordionStatus(e, toggle, index) {
    e.preventDefault();
    if (e.target.classList.contains('accordion-header') || e.target.parentElement.classList.contains('accordion-header') || e.target.classList.contains('accordion-title') || e.target.classList.contains('accordion-toggle')) {
      this.configData.groups[index].open = !toggle;
      //console.log(this.configData.groups);
    }
  }
  getFormVisibility(index) {
    if (this.configData.screenVersion && this.configData.screenVersion === 'v2') {
      if (this.configData.header.stepper.labels[index]) {
        if (this.configData.header.stepper.labels[index].show)
          return '';
        else
          return 'hideForm';
      } else
      return 'hideForm';
    }
  }
  getColsClassByConfigData(configHeader){
    let colsClass = '';
    //configData.header?.action?.nav || configData.header?.action?.ellipse ?
    let templateName=localStorage.getItem('templateName');
    if((configHeader.action?.ellipse && (localStorage.getItem('customerCode') === 'VITESCO' && templateName === "releaseOrderViewEdit" || "orderViewEdit"))){
      colsClass= 'col-lg-11 col-sm-11 col-xs-11';
     }
    else if(configHeader.action?.nav || configHeader.action?.ellipse){
     colsClass= 'col-lg-9 col-sm-9 col-xs-12';
    }
    else if(configHeader?.header?.headerInfo){
      colsClass='col-lg-11 col-sm-11 col-xs-12' ;
    }
    else{
      colsClass='col-lg-12 col-sm-12 col-xs-12' ;
    }
  return colsClass;
  }
  getColsClassForConditionBase(configHeader){
    let colsClass = '';
    let templateName=localStorage.getItem('templateName');
    if (configHeader.action?.ellipse && (localStorage.getItem('customerCode') === 'VITESCO' && templateName === "releaseOrderViewEdit" || "orderViewEdit")) {
      colsClass = 'col-lg-1 col-sm-1 d-none d-sm-block';
    }
    else if (configHeader.action?.nav || this.headerDetails === undefined || configHeader.action?.ellipse) {
      colsClass = 'col-lg-3 col-sm-3 d-none d-sm-block';
    }
    else {
      colsClass = 'col-lg-1 col-sm-1 d-none d-sm-block';
    }
    return colsClass;

  }
  getColsClass(cols: number[], control?: any) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols?.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    if(control && navigator.userAgent.toLowerCase().indexOf("mobile") > -1 ){   // hard coded
      if(control && control["component"] == "SEARCHBOX_V2" && control["name"] == "SearchBox"){
        colsClass += "makeDwarf searchBoxMobileView";
      }
      if(control && control["component"] == "FORM_FILTER_V2" && control["name"] == "formFilter"){
        colsClass += "makeDwarf formFilterMobileView";
      }
    }
    if(control && control.hasOwnProperty("makeDwarf") && control.makeDwarf){
      colsClass += 'dwarf' + ' ';
    }
    if(control && control.hasOwnProperty("customCols") && control.customCols){
      colsClass += 'customCols' + ' ';
    }
    return colsClass;
  }
  get f() { return this.frmGroup.controls; }

  validateAllFormFields(formGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl && control.errors) {
        this.totalError += 1;
        if (control.errors.required) {
          control.markAsTouched({ onlySelf: true });
          control.markAsDirty({ onlySelf: true });
        }
      }else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      } else if (control instanceof UntypedFormArray) {
        control.controls.forEach(data => {
          this.validateAllFormFields(data);
        })
      }
    });
  }

  validateShipUnitCount(): boolean {
    let totalShipUnitCount = 0;
    let totalQtyRelease = 0;
    let totalShipWeightCount = 0;
    let totalPoWeight = 0;

    this.frmGroup.controls.shipCard["controls"].forEach((group) => {
      Object.keys(group.value).forEach((control) => {
        if (control === "huCount" && group.value[control]) {
          totalShipUnitCount += parseInt(group.value[control]);
        }
      });
    }, this);
    console.log(totalShipUnitCount);
    this.frmGroup.controls.poLines["controls"].forEach((group) => {
      Object.keys(group.value).forEach((control) => {
        if (control === "qtyRelease" && group.value[control]) {
          totalQtyRelease += parseInt(group.value[control]);
        }
      });
    }, this);

    if (this.configData?.validationError) {
      this.frmGroup.controls.shipCard["controls"].forEach((group) => {
        Object.keys(group.value).forEach((control) => {
          if (control === "weight" && group.value[control]) {
            let huCount = group.value["huCount"] || 1;
            totalShipWeightCount += +group.value[control] * huCount;
          }
        });
      }, this);
      this.frmGroup.controls.poLines["controls"].forEach((group) => {
        Object.keys(group.value).forEach((control) => {
          if (control === "weightPo" && group.value[control]) {
            totalPoWeight += parseInt(group.value[control]);
          }
        });
      }, this);
      if (totalPoWeight > totalShipWeightCount) {
        let msgObj = { totalShipCount: this.configData?.validationError };
        this.frmGroup.controls.shipCard.setErrors(msgObj);
        this.frmGroup.controls.shipCard["controls"].forEach((group) => {
          group.get("weight").setErrors(msgObj);
        }, this);
        return false;
      } else {
        this.frmGroup.controls.shipCard["controls"].forEach((group) => {
          if (+group?.get("weight")?.value > 0) {
            group.get("weight").setErrors(null);
            this.appService?._components["weight"]?.frmGroup
              ?.get("weight")
              ?.clearValidators();
            this.appService?._components["weight"]?.frmGroup
              ?.get("weight")
              ?.updateValueAndValidity();
          }
        }, this);
        return true;
      }
    }
    if (totalShipUnitCount > totalQtyRelease) {
      let msgObj = {
        totalShipCount:
          "Total ship unit count can't be greater than total release quantity",
      };
      this.frmGroup.controls.shipCard.setErrors(msgObj);
      this.frmGroup.controls.shipCard["controls"].forEach((group) => {
        group.get("huCount").setErrors(msgObj);
      }, this);
      return false;
    } else {
      this.frmGroup.controls.shipCard["controls"].forEach((group) => {
        const huCountControl = group.get("huCount");
        // Re-run validators to drop the manual totalShipCount error while keeping required/pattern
        if (huCountControl?.errors?.totalShipCount) {
          huCountControl.updateValueAndValidity();
        }
      }, this);
      return true;
    }
  }

  formError: String = '';
  isSubmitted: boolean = false;

  submitOrderForm(e, data, label) {
    this.totalError = 0;
    this.isLoading = true;
    this.ArrayOfFilledFields = [];
    this.isDarftGetError = false;
    document.getElementById("overlay").style.display = "block";

    localStorage.setItem('lastShipCard', 'false');
    this.isSubmitted = true;

    this.formStatus.emit(this.isSubmitted);

    this.alphaService.executeGroupValidations({
      validations: this.configData.groupValidations,
      formGroup: this.frmGroup,
      shouldValidate: true,
      shouldSubscribe: false,
    });

     // release order start
     if ((this.configData.name === 'releaseOrder') || (this.configData.name === 'releaseOrderViewEdit')) {
      if (this.frmGroup.controls.hasOwnProperty('shipCard')) {
      let shipControl = this.frmGroup.controls.shipCard['controls'];
      let count = 0;
      for (let g in shipControl[shipControl.length - 1].value) {
        console.log(shipControl[shipControl.length - 1].value[g]);
        if (shipControl[shipControl.length - 1].value[g] === null || shipControl[shipControl.length - 1].value[g] === '') {
          count += 1;
        }
      }
      if (!this.validateShipUnitCount()) {
        this.validateAllFormFields(this.frmGroup);
        this.normalView();
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
        return false;
      }

      if (count === Object.keys(shipControl[shipControl.length - 1].value).length && shipControl.length > 1) {
        (<UntypedFormArray>this.frmGroup.controls['shipCard']).removeAt((<UntypedFormArray>this.frmGroup.controls['shipCard']).length - 1);
        localStorage.setItem('lastShipCard', 'true');
      } else if (count === Object.keys(shipControl[shipControl.length - 1].value).length && shipControl.length === 1) {
        console.log(this.frmGroup.controls.shipCard['controls']);
        this.frmGroup.controls.shipCard.setErrors({ 'shipCard': 'Please fill shipping unit details.' })
      }
    }
    }
    // release order end
    if (this.frmGroup.invalid && !data.groupValidationRemove) {
      this.validateAllFormFields(this.frmGroup);
      this.normalView();
      this.isLoading = false;

      if (data.validateLastStep) {
        this.appService._formErrorCheck.next({ "lastFormError": data.validateLastStep });
      }
      let grpIndex = [];
      if(this.configData.groups){
        this.configData.groups.map((data, index) => {
          data.open = true;
          //CP-9621-start-collapse group if fields of group contains error
          if(data.component === 'ACCORDION_V2') {
            data.controls.forEach((ctrl) => {
              if(this.frmGroup.controls[ctrl.name].invalid){
                data.isActive = true;
                grpIndex.push(index);
              }
            })
          }
        });
      }
      if(grpIndex.length) {
        const eleId = "accordion" + grpIndex[0];
          document.getElementById("accordion" + grpIndex[0]).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
      } // CP-9621-end
      return false; 
    }else if(this.configData.screenVersion == 'v2'){
      this.loadingStatus.emit(this.isLoading);
    }

    if (this.configData?.newFeatures) {
      this.addNewFeatures(this.frmGroup, this.configData.newFeatures);
    }
    this.appService.setRawFormValue({'name': this.configData.name, 'value': this.frmGroup.getRawValue()});
    let orderData : any;
    orderData = this.formService.formatOrderObject(this.frmGroup.controls);
    if (this.configData.payloadFormat && this.configData.payloadFormat === 'SIMPLE') {
      orderData = this.formService.simpleFormatObject(orderData);
    } else if (this.configData.payloadFormat && this.configData.payloadFormat === 'PARAMS_AND_TABLES') {
      orderData = this.formService.simpleFormatObject(orderData);
      orderData = this.formService.formatToParamsAndTables(orderData);
    } else if (this.configData.payloadFormat && this.configData.payloadFormat === 'PARAMS_AND_TABLES_V2') {
      orderData = this.formService.formatToParamsAndTablesV2(orderData);
    } else if (this.configData.payloadFormat && this.configData.payloadFormat === 'DYNAMIC_PARAMS_V2') {
      orderData = this.formService.formatDynamicParamsV2(this.configData?.requestData, orderData);
    } else if (this.configData.payloadFormat && this.configData.payloadFormat === 'DYNAMIC_ACCORDION') {
      orderData = this.formService.formatDynamicAccordion(orderData);
      if(this.orderDetails && this.orderDetails?.data?.businessObject.businessObjectId){
        let businessObjectId = this.orderDetails.data.businessObject.businessObjectId;
        let businessObjectNumber = this.orderDetails.data.businessObject.businessObjectNumber;
        let status = this.orderDetails.data.businessObject.status; // In save order status will remain same
        orderData = { businessObjectId, businessObjectNumber, status, ...this.configData?.additionalPayloadData, ...orderData };
       this.sendViewResponseToBackend(orderData)
      } else {
        this.sendViewResponseToBackend(orderData)
      }

    }

    console.log(JSON.stringify(orderData));

    // create apiUrl dynamically and make api call
    let postUrl = '';
    let transmissionUrl = '';
    let redirectUrl = '';
    let method = '';
    let modalName = '';
    let modalTitle = '';
    let modalDescription = '';
    let modalActionText = '';
    let modalDismissText = '';

    console.log('Action Submit ', this.configData, ' Action ', this.configData.actions)
    if(this.configData.actions){
    this.configData.actions.forEach(action => {
      if (action.type === 'submit' && action.command.ajax) {
        postUrl = action.command.httpConfig.request.postUrl;
        const roleBasedPostUrl = action.command.httpConfig.request.roleBasedPostUrl;
        if (roleBasedPostUrl) {
          const userRole = localStorage.getItem('userRole');
          const matched = roleBasedPostUrl.find(r => r.accessedRoles?.includes(userRole));
          if (matched) postUrl = matched.postUrl;
        }
        postUrl += localStorage.getItem('customerCode') + '&userId=' + localStorage.getItem('userName');

        transmissionUrl = action.command.httpConfig.request.transmissionUrl;
        if (transmissionUrl !== "")
          transmissionUrl += localStorage.getItem('customerCode') + '&userId=' + localStorage.getItem('userName') + '&orderId=';

        redirectUrl = action.command.httpConfig.redirectUrl;
        if (action.command.httpConfig.method)
          method = action.command.httpConfig.method;

        modalName = action.command.modal.name;
        modalTitle = action.command.modal.title;
        modalDescription = action.command.modal.description ? action.command.modal.description : '';
        modalActionText = action.command.modal.actionButtonActionText ? action.command.modal.actionButtonActionText : '';
        modalDismissText = action.command.modal.actionButtonDismissText ? action.command.modal.actionButtonDismissText : '';
      }
    });
    }

    if (this.configData.name === 'rateEnquirySearch') {
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        name: this.configData.name,
        action: 'SUBMIT',
        data: {
          url: postUrl,
          transmissionUrl: transmissionUrl,
          redirectUrl: redirectUrl,
          postData: orderData,
          defaultPostBodyData: data.command.httpConfig.request.defaultPostBodyData,
          method: method,
          modal: { 'name': modalName, 'title': modalTitle }
        }
      })

      // this.makeApiCall(postUrl, transmissionUrl, redirectUrl, orderData, method, { 'name': modalName, 'title': modalTitle });
    }
    // create apiUrl dynamically and make api call
    // if (this.configData.name === 'customerOnBoard'){
    //   this.makeApiCall(postUrl, transmissionUrl, redirectUrl, orderData);
    // }


    if ((this.configData.name === 'releaseOrder') || (this.configData.name === 'releaseOrderViewEdit')) {
      orderData.param['orderBaseId1'] = orderData.table[0].poLines[0].poLineItemId2;
      let arrayOfPoLineItemId  = orderData.table[0].poLines.map((val) => {
        let poLineItemId1;
        poLineItemId1 = val.poLineItemId1;
        let lastIndexOfHyphen;
        lastIndexOfHyphen = poLineItemId1.indexOf('-0') > -1 ? poLineItemId1.lastIndexOf('-') : poLineItemId1.indexOf('_0') > -1 ? poLineItemId1.lastIndexOf('_') : poLineItemId1;
        return !isNaN(lastIndexOfHyphen)  ?  poLineItemId1.slice(0, lastIndexOfHyphen) : lastIndexOfHyphen;
      });
    }

    if(this.configData.name === 'customerOnBoard' || this.configData.name === 'dataUpload'){
      this.isLoading = false;
      this.normalView();
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        name: this.configData.name,
        action: 'SUBMIT',
        data: {
          url: postUrl,
          transmissionUrl: transmissionUrl,
          redirectUrl: redirectUrl,
          postData: orderData,
          method: method,
          modal: { 'name': modalName, 'title': modalTitle }
        }
      })
    }
    if (this.configData.name === 'orderCancel') {
      this.isLoading = false;
      this.normalView();
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        name: this.configData.name,
        action: 'SUBMIT',
        data: {
          url: postUrl,
          transmissionUrl: transmissionUrl,
          redirectUrl: redirectUrl,
          postData: orderData,
          method: method,
          modal: {
            'actions': true,
            'name': modalName,
            'title': modalTitle,
            'modalForm': {
              type: "customTextModal"
            },
            'description':modalDescription,
            'actionButtonActionText':modalActionText,
            'actionButtonDismissText':modalDismissText

          }
        }
      })
    }
    if ((this.configData.name === 'selfConfig_BE_ParentXML')) {
      let apiUrl: string = '';
      let observable;
      let transmissionCheckUrl = '';
      apiUrl = APP_Constants.UI_SELF_CONFIG_SAVE + localStorage.getItem('userName') +
        '&customerCode=' + this.orderDetails.customerCode +
        '&configId=' + this.orderDetails.configId +
        '&action=' + this.orderDetails.action+
        '&draftType=' + this.orderDetails.templateType
      if (this.orderDetails.templateType === 'childXML') {
        apiUrl += '&parentKeyword=' + this.orderDetails.parentKeyword +
          '&templateKeyword=' + this.orderDetails.templateKeyword 
      }
      else if (this.orderDetails.templateType === 'draftQuery'){
        delete orderData?.param?.xmlContent;
      }
      observable = this.appService.makeHttpPostRequest(apiUrl, orderData);

      this.appService.makeHttpPostRequest(apiUrl, orderData).subscribe(res => {
        if (res['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          this.formError = ''
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
          this.normalView();
          let saveDraftMsg = `Draft XML saved`;
          this._snackBar.open({ message: saveDraftMsg }, { duration: this.durationInSeconds * 1000 });
          let routeUrl = this.configData?.header?.action?.redirectUrl; //? this.configData?.header?.action?.redirectUrl : '/orders';
            this.router.navigateByUrl(routeUrl);
        }
      }, err => {
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
        this.normalView();

        let modal = new Modal({
          action: false, name: 'Orders', title: 'Order Entry', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });

    }

    if ((this.configData.name === 'orderViewEdit') || (this.configData.name === 'releaseOrderViewEdit')) {
      let apiUrl: string = '';
      let observable;
      let transmissionCheckUrl = '';
      if (this.configData.name === 'releaseOrderViewEdit') {
        const isCache = this.configData?.isCache;
        const editReleaseSaveOrderLink = isCache ? APP_Constants.RELEASE_EDIT_SAVE_ORDER_LINK_CACHE : APP_Constants.RELEASE_EDIT_SAVE_ORDER_LINK;
        apiUrl = editReleaseSaveOrderLink + localStorage.getItem('EditOrderReleaseId') +
          '&userId=' + localStorage.getItem('userName') +
          '&customerCode=' + localStorage.getItem('customerCode');
        transmissionCheckUrl = isCache ? APP_Constants.RELEASE_EDIT_ORDER_TRANSMISSION_STATUS_CACHE : APP_Constants.RELEASE_EDIT_ORDER_TRANSMISSION_STATUS;

      }else if(this.configData?.apiUrlForUpdate && this.configData?.payloadFormat === "DYNAMIC_ACCORDION")
      {
        apiUrl=this.configData?.apiUrlForUpdate+ localStorage.getItem('customerCode') +"&userId=" +localStorage.getItem('userName') + "&action=updateOrder"
      } else if (!this.configData?.apiUrlForUpdate) {
        const isCache = this.configData?.isCache;
        const editSaveOrderLink = isCache ? APP_Constants.EDIT_SAVE_ORDER_LINK_CACHE : APP_Constants.EDIT_SAVE_ORDER_LINK;
        const orderReleaseId = orderData.param['orderReleaseId'];
        const userName = localStorage.getItem('userName');
        const customerCode = localStorage.getItem('customerCode');
        let action = this?.configData?.action ? this?.configData?.action : 'VIEWEDIT_ORDER';

        apiUrl = `${editSaveOrderLink}${orderReleaseId}&userId=${userName}&customerCode=${customerCode}&action=${action}`;

        if (action === 'SHIPMENT_CONFIRMATION') {
          transmissionCheckUrl = APP_Constants.SHIPMENT_CONFIRMTAION_TRANSMISSION_STATUS;
        } else {
          transmissionCheckUrl = isCache ? APP_Constants.EDIT_ORDER_TRANSMISSION_STATUS_CACHE : APP_Constants.EDIT_ORDER_TRANSMISSION_STATUS;
        }
      }
      if (this.configData?.xmlBasedOnOrderType === true) {
        this.alphaService.formatInboundOutboundPayload(orderData);
      }
      if (this.configData.name === 'releaseOrderViewEdit') {
        observable = this.appService.makeHttpPutRequest(apiUrl, orderData);
      } else {
        observable = this.appService.makeHttpPostRequest(apiUrl, orderData);
      }

      observable
        .subscribe(data => {
          console.log(data);
          if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
            this.formError = '';
            let times = 0;
            if (this.configData?.apiUrlForUpdate && this.configData?.payloadFormat === "DYNAMIC_ACCORDION") {
              this.loadingStatus.emit(this.isLoading);
              this.normalView();
              this._snackBar.open({ message: data['data'].businessObjectId + " : " + data['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });

              let routeUrl = this.configData?.header?.action?.redirectUrl ? this.configData?.header?.action?.redirectUrl : '/orders';
              this.router.navigateByUrl(routeUrl);
          } else {
            let transmissionStatus;
            setTimeout(() => {
              this.appService.makeHttpGetRequest(transmissionCheckUrl + localStorage.getItem('customerCode') +
                '&orderId=' + data['orderId'] +
                '&transmissionNo=' + data['transmissionNo'] +
                '&userId=' + localStorage.getItem('userName'),
              ).subscribe(
                data => {
                  console.log(data);
                  transmissionStatus = data;
                  if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                    this.isLoading = false;
                    this.loadingStatus.emit(this.isLoading);
                    this.normalView();
                    this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                    let routeUrl = this.configData?.header?.action?.redirectUrl ? this.configData?.header?.action?.redirectUrl : '/orders';
                    this.router.navigateByUrl(routeUrl);
                    localStorage.removeItem('TotalPoLinesSelected');
                    localStorage.removeItem('ResetPoSelected');
                  }
                }, err => {
                  this.isLoading = false;
                  this.loadingStatus.emit(this.isLoading);
                  this.normalView();
                  let modal = new Modal({
                    action: false, name: 'orderStatus', title: 'Order status', description: err.message, actionButtonText: ''
                  });
                  this.modalService.createModalBox(modal, err.status);
                });
              let intervalId = setInterval(() => {
                if (
                  transmissionStatus &&
                  (
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE
                  )) {
                  this.isLoading = false;
                  this.loadingStatus.emit(this.isLoading);
                  this.normalView();
                  clearInterval(intervalId);
                } else if (++times == 5 && transmissionStatus && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.IN_PROGRESS_CODE) {
                  this.isLoading = false;
                  this.loadingStatus.emit(this.isLoading);
                  this.normalView();
                  this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                  this.router.navigateByUrl('/orders');
                  localStorage.removeItem('TotalPoLinesSelected');
                  localStorage.removeItem('ResetPoSelected');
                  clearInterval(intervalId);
                } else {
                  this.appService.makeHttpGetRequest(transmissionCheckUrl + localStorage.getItem('customerCode') +
                    '&orderId=' + data['orderId'] +
                    '&transmissionNo=' + data['transmissionNo'] +
                    '&userId=' + localStorage.getItem('userName'),
                  ).subscribe(
                    data => {
                      console.log(data);
                      transmissionStatus = data;
                      if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                        transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                        this.isLoading = false;
                        this.loadingStatus.emit(this.isLoading);
                        this.normalView();
                        this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                        let routeUrl = this.configData?.header?.action?.redirectUrl ? this.configData?.header?.action?.redirectUrl : '/orders';
                        this.router.navigateByUrl(routeUrl);
                        localStorage.removeItem('TotalPoLinesSelected');
                        localStorage.removeItem('ResetPoSelected');
                      }
                    }, err => {
                      this.isLoading = false;
                      this.loadingStatus.emit(this.isLoading);
                      this.normalView();
                      let modal = new Modal({
                        action: false, name: 'orderStatus', title: 'Order status', description: err.message, actionButtonText: ''
                      });
                      this.modalService.createModalBox(modal, err.status);
                      // this.formError = data['message'].statusMessage;
                      // setTimeout(() => {
                      //   let elem = document.getElementById('error');
                      //   elem.focus();
                      // }, 10);
                      console.log(err);
                    });
                }
              }, 3000);

            }, 1000);
          }

          }
          // check if below code is of any use
          else if (data['message'].statusCode == APP_Constants.ERROR_CODE) {
            this.isLoading = false;
            this.normalView();
            console.log(data['message'].statusMessage);
            this.formError = data['message'].statusMessage;
            setTimeout(() => {
              let elem = document.getElementById('error');
              elem.focus();
            }, 10);
          }
        }, err => {
          this.isLoading = false;
          this.normalView();

          let modal = new Modal({
            action: false, name: 'editOrder', title: 'Edit order', description: err.message, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);

          // this.formError = err;
          // setTimeout(() => {
          //   let elem = document.getElementById('error');
          //   elem.focus();
          // }, 10);
          // console.log('Error while getting the response from server.');
          console.log(err)
        }
        );
    }
     else if ((this.configData.name === 'gskOrderEntry' || this.configData.name === 'orderEntry' || this.configData.name === 'releaseOrderWithStatus' || this.configData.name === 'releaseOrder') && data.name == 'draftOrder' ) {    
      let API = data.command.url + localStorage.getItem('customerCode') + '&userId=' + localStorage.getItem('userName');
      let invalidFieldsArray = [], additionalPayloadData;
      
      if (this.configData?.payloadFormat == "DYNAMIC_ACCORDION") {
       if ((orderData?.orderDetailsStepOne?.prefrenceId ?? '') !== '') {
          API += '&prefrenceId=' + orderData?.orderDetailsStepOne?.prefrenceId;
          if (data?.payload?.requestType) {
            data.payload.requestType = 'update'
          }
        }
        delete orderData.orderDetailsStepOne.prefrenceId;
        const { filledFields, invalidFields, totalErrors } = this.formService.validateDraftOrderFormRecursively(this.configData?.enableDraftSaveWithErrors?.excludeItems,this.frmGroup, [], orderData);
        this.ArrayOfFilledFields = filledFields;
        invalidFieldsArray = invalidFields;
        this.totalError = totalErrors;
        if(data?.payload) {
          additionalPayloadData = data.payload;
          orderData = { ...additionalPayloadData, ...orderData }
        }
      } else {
        if (orderData?.param?.prefrenceId && orderData?.param?.prefrenceId != ''){
          API += '&prefrenceId=' + orderData.param.prefrenceId;
        }
        //Add new object view and other
        let localStorageLocation = localStorage.getItem("selectedLocation");
        orderData["param"]["locationDetails"] = localStorageLocation ? JSON.parse(localStorageLocation) : null;
        //End
        let orderParam = orderData?.param;
        let orderTable = orderData?.table;

        if (this.configData?.apiConfigForRelease) {
          orderParam.documentIds = this.alphaService.getDocumentIds();
          this.alphaService.clearDocumentIds();
        }
        delete orderData?.param?.prefrenceId;
        //Check Data availbility and fields validation
        let arrayOfControls = {};
        let isSectionsStepper = this.configData.hasOwnProperty('sections') && this.configData?.sections?.length > 0 && this.configData?.sections[0].component === "STEPPER";
        if(isSectionsStepper){
          for (let i = 0; i < this.configData?.sections.length; i++) {
            const objData = this.configData?.sections[i];
            let formGroupx : any =(this.frmGroup.get(objData?.name) as UntypedFormArray).at(0);
            arrayOfControls = {...arrayOfControls, ...formGroupx.controls}
          }
          //frmGroupData = new FormGroup(arrayOfControls);
        }

        this.ArrayOfFilledFields = Object.keys(orderParam).filter((val) => orderParam[val] != null && orderParam[val] != undefined && orderParam[val] != '' && typeof orderParam[val] !== 'object');
        //let invalidFieldsArray = [];
        if (this.ArrayOfFilledFields?.length > 0) {
          invalidFieldsArray = this.ArrayOfFilledFields?.filter((val) => isSectionsStepper ? arrayOfControls[val]?.invalid : this.frmGroup.get(val)?.invalid);
        }
        for (let a = 0; a < orderTable.length; a++) {
          const tableFormGroup = orderTable[a];
          Object.keys(tableFormGroup);
          let tableKey = Object.keys(tableFormGroup)[0];
          const formArray = isSectionsStepper ? (arrayOfControls[tableKey] as UntypedFormArray) :  (this.frmGroup.get(tableKey) as UntypedFormArray);
          let arrayOfDataValue: any = Object.values(tableFormGroup)[0];
          for (let b = 0; b < arrayOfDataValue.length; b++) {
            const filledFieldsArray = Object.keys(arrayOfDataValue[b]).filter((val) => arrayOfDataValue[b][val] != null && arrayOfDataValue[b][val] != undefined && arrayOfDataValue[b][val] != '' && typeof orderParam[val] !== 'object');
            if (filledFieldsArray.length > 0) {
              this.ArrayOfFilledFields = this.ArrayOfFilledFields?.concat(filledFieldsArray);
              const validateArray = filledFieldsArray.filter((val) => formArray.at(b)?.get(val)?.invalid)
              invalidFieldsArray = invalidFieldsArray.concat(validateArray);
            }
          }
        }
        this.totalError = invalidFieldsArray.length;
      }

      if (this.ArrayOfFilledFields?.length == 0 || this.totalError > 0) {
        if (this.configData && this.configData.bannerDetails) {
          this.configData.bannerDetails.banner = true;
        }
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
        this.normalView();
        this.isDarftGetError = true;
        return;
      } else {
        this.isDarftGetError = false;
      }
      //End
      if(this.configData.name === 'releaseOrderWithStatus'){
        let locationDetails = orderData.param.locationDetails;
        if (locationDetails && locationDetails.origin && locationDetails.origin.locationId &&
          locationDetails.destination && locationDetails.destination.locationId){
        orderData.table[0].poLines[0].shipFromId = locationDetails.origin.locationId;
        orderData.table[0].poLines[0].shipFromName = locationDetails.origin.locationName
        orderData.table[0].poLines[0].shipToId = locationDetails.destination.locationId
        orderData.table[0].poLines[0].shipToName = locationDetails.destination.locationName
        }
      }
      this.appService.makeHttpPostRequest(API, orderData).subscribe(res => {
        if (res['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          this.formError = ''
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
          this.normalView();
          let preferenceId = res['data'].preferenceId;
          let saveDraftMsg = `Draft ${preferenceId} created`;
          this._snackBar.open({orderId: preferenceId,message: saveDraftMsg }, { duration: this.durationInSeconds * 1000 });
          if(data.command && data.command.redirectUrl && data.command.redirectUrl != '') this.router.navigateByUrl(data.command.redirectUrl);
          localStorage.removeItem("selectedLocation");
        }
      }, err => {
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
        this.normalView();

        let modal = new Modal({
          action: false, name: 'Orders', title: 'Order Entry', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
    }
    else if (this.configData.name === 'orderEntry') {
      const isCache = this?.configData?.isCache;
      let action = this?.configData?.action ? this?.configData?.action : 'CREATE_ORDER';
      const orderEntryPath = isCache ? APP_Constants.CREATE_ORDER_LINK_CACHE : APP_Constants.CREATE_ORDER_LINK;
      const customerCode = localStorage.getItem('customerCode');
      const userName = localStorage.getItem('userName');
      const orderEntryURL = `${orderEntryPath}${customerCode}&userId=${userName}&action=${action}`;
      if(this.configData?.xmlBasedOnOrderType === true){
        this.alphaService.formatInboundOutboundPayload(orderData);
      }

      if (this.configData?.apiConfigForRelease) {
        const validationResult =
          this.alphaService.finalReleaseCallValidation(
            this.orderDtls?.rawData?.documentIds
          );

        this.documentUploadIds = validationResult.documentIds;

        if (!validationResult.isValid) {
          let errorMsg = "Document upload is mandatory based on shipment conditions.";
          let modal = new Modal({
            action: false, name: 'orderCancelInvalid', title: 'Mandatory Document', description: errorMsg, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, 'ERROR');
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
          this.normalView();
          return;
        }
      }
      this.appService.makeHttpPostRequest(orderEntryURL, orderData).subscribe(data => {
          if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
            this.formError = ''
            let times = 0;
            let transmissionStatus;
            setTimeout(() => {
              const transmissionPath = isCache ? APP_Constants.CREATE_ORDER_TRANSMISSION_STATUS_CACHE : APP_Constants.CREATE_ORDER_TRANSMISSION_STATUS;
              const orderId = data['orderId'];
              const transmissionNo = data['transmissionNo'];
              const transmissionURL = `${transmissionPath}${customerCode}&orderId=${orderId}&transmissionNo=${transmissionNo}&userId=${userName}`;
              this.appService.makeHttpGetRequest(transmissionURL).subscribe(
                data => {
                  console.log(data);
                  transmissionStatus = data;
                   //Start Delete API will be called whenever an order is created from a draft order.
                   let preferenceId = orderData?.param?.prefrenceId || null;
                   if (preferenceId && preferenceId !='' && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE) {
                     this.alphaService.deleteDraftOrder(preferenceId);
                   }
                   //End
                  if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                    this.isLoading = false;
                    this.loadingStatus.emit(this.isLoading);
                    this.normalView();
                    this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                    let routeUrl = this.configData?.header?.action?.redirectUrl ? this.configData?.header?.action?.redirectUrl : '/orders';
                    if (this.configData?.apiConfigForRelease && this.documentUploadIds?.length > 0 && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE) {
                      this.alphaService.releaseUploadedDocuments(this.documentUploadIds, data['orderId'],this.configData?.apiConfigForRelease)
                      this.alphaService.clearDocumentIds();
                    }
                    this.router.navigateByUrl(routeUrl);
                    localStorage.removeItem('TotalPoLinesSelected');
                    localStorage.removeItem('ResetPoSelected');
                  }

                }, err => {
                  this.isLoading = false;
                  this.loadingStatus.emit(this.isLoading);
                  this.normalView();

                  let modal = new Modal({
                    action: false, name: 'orderStatus', title: 'Order status', description: err.message, actionButtonText: ''
                  });
                  this.modalService.createModalBox(modal, err.status);
                  console.log(err);
                });

              let intervalId = setInterval(() => {
                if (
                  transmissionStatus &&
                  (
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE
                  )) {
                  this.isLoading = false;
                  this.loadingStatus.emit(this.isLoading);
                  this.normalView();
                  clearInterval(intervalId);
                } else if (++times == 5 && transmissionStatus && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.IN_PROGRESS_CODE) {
                  this.isLoading = false;
                  this.loadingStatus.emit(this.isLoading);
                  this.normalView();
                  this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                  this.router.navigateByUrl('/orders');
                  localStorage.removeItem('TotalPoLinesSelected');
                  localStorage.removeItem('ResetPoSelected');
                  clearInterval(intervalId);
                } else {
                  this.appService.makeHttpGetRequest(transmissionURL).subscribe(
                    data => {
                      console.log(data);
                      this.loadingStatus.emit(this.isLoading);
                      transmissionStatus = data;
                      //Start Delete API will be called whenever an order is created from a draft order.
                      let preferenceId = orderData?.param?.prefrenceId || null;
                      if (preferenceId && preferenceId != '' && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE) {
                        this.alphaService.deleteDraftOrder(preferenceId);
                      }
                      //End
                      if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                        transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                        this.isLoading = false;
                        this.normalView();
                        this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                        if (this.configData?.apiConfigForRelease && this.documentUploadIds?.length > 0 && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE) {
                          this.alphaService.releaseUploadedDocuments(this.documentUploadIds, data['orderId'],this.configData?.apiConfigForRelease)
                          this.alphaService.clearDocumentIds();
                        }
                        this.router.navigateByUrl('/orders');
                        localStorage.removeItem('TotalPoLinesSelected');
                        localStorage.removeItem('ResetPoSelected');
                      }
                    }, err => {
                      this.isLoading = false;
                      this.loadingStatus.emit(this.isLoading);
                      this.normalView();

                      let modal = new Modal({
                        action: false, name: 'orderStatus', title: 'Order status', description: err.message, actionButtonText: ''
                      });
                      this.modalService.createModalBox(modal, err.status);
                      console.log(err);
                    });
                }
              }, 3000);
            }, 1000);
          }
        }, err => {
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
          this.normalView();

          let modal = new Modal({
            action: false, name: 'Orders', title: 'Order Entry', description: err.message, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);
        });
      localStorage.removeItem("selectedLocation");
    }
    else if (this.configData.name === 'carrierEntry') {
     this.appService.makeHttpPostCallWithoutRetry(APP_Constants.CREATE_CARRIER_LINK + localStorage.getItem('customerCode') + '&userId=' +
        localStorage.getItem('userName'), orderData).subscribe(res => {
          if (res['message'].statusCode == APP_Constants.SUCCESS_CODE) {
            this.isLoading = false;
            this.loadingStatus.emit(this.isLoading);
            this.normalView();
            let carrierObjectId = res['data']?.businessObjectIds[0]?.businessObjectId || '';
            let statusMessage = res['message'].statusMessage + ' ' +carrierObjectId;
            this._snackBar.open({ message: statusMessage }, { duration: this.durationInSeconds * 1000 });
            if (data['view']['buttonType'] == "resetAndApiCall") {
              this.formReset('reset');
            } else {
              this.router.navigateByUrl('/carrier');
            }
            localStorage.removeItem('TotalPoLinesSelected');
            localStorage.removeItem('ResetPoSelected');
          }
        }, err => {
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
          this.normalView();
          let error = err?.error?.data?.errorMessage?.errorMessage?.errors
          let errorResponse = (error && !Array.isArray(error)) ? error : (error && Array.isArray(error)) ? error[0] : this.constant.GENERIC_ERROR_MESSAGE;
          this._snackBar.open({ message: errorResponse}, { duration: this.durationInSeconds * 1000 });
        });
      localStorage.removeItem("selectedLocation");
    }
    else if (this.configData.name === 'releaseOrder') {
       this.releaseOrderCall(orderData);
    }
    else if (this.configData.name === 'releaseOrderWithStatus') {
      orderData.table[0].poLines.forEach((elem) => {
          let url = APP_Constants.RELEASE_ORDER_STATUS_LINK + '&searchString=' + elem.poLineItemId2 + '&userId=' + localStorage.getItem('userName') + '&customerCode=' + localStorage.getItem('customerCode');
          this.appService.makeHttpGetRequest(url).subscribe(
            data => {
              const currentUrl = localStorage.getItem('filterCurrenturl')
              if (currentUrl === '/orders/draft') {
                const draftData = JSON.parse(localStorage.getItem('templatedata'));
                orderData.param.prefrenceId = draftData.prefrenceId
                }
              if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
                //Start Delete API will be called whenever an order is created from a draft order.
                let preferenceId = orderData?.param?.prefrenceId || null;
                let transmissionStatus = data;
                if (preferenceId && preferenceId !='' && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE) {
                  this.alphaService.deleteDraftOrder(preferenceId);
                  localStorage.removeItem('templatedata')
                }
                //End
                if (this.configData.excludedStatus.indexOf(data['searchResult'][0].OB_STATUS_TYPE) > -1) {
                  this.releaseOrdercall = true;
                  this.includeStatuscall = false;
                  this.isLoading = false;
                  this.normalView();
                  let modal = new Modal({
                    action: false, name: 'Orders', title: "Load Plan Status ", description: "One or more Orders are not in  " + this.configData.includeStatus +
                      " status. Please go back to Vehicle Order screen and select again the Orders for Load Planning", actionButtonText: ''
                  });
                  this.modalService.createModalBox(modal, data['message'].statusCode);
                }
                else if (this.includeStatuscall == true && this.configData.includeStatus.indexOf(data['searchResult'][0].OB_STATUS_TYPE) > -1) {
                  this.includeStatuscall = true;
                  this.releaseOrdercall = true;
                }
                else if ((this.releaseOrdercall == false && this.includeStatuscall == false) && this.configData.includeStatus.indexOf(data['searchResult'][0].OB_STATUS_TYPE) > -1) {
                  this.includeStatuscall = false;
                  this.releaseOrdercall = false;
                }
              }
            });
      });
        this.timeout = setTimeout(() => {
        if(this.releaseOrdercall == false && this.includeStatuscall == false){
          this.releaseOrderCall(orderData)
        }
       }, 4 * 1000);     
    }
    // else if (this.configData.name === 'releaseOrderWithStatus') {
    //   orderData.table[0].poLines.forEach((elem) => {
    //       let url = APP_Constants.RELEASE_ORDER_STATUS_LINK + '&searchString=' + elem.poLineItemId2 + '&userId=' + localStorage.getItem('userName') + '&customerCode=' + localStorage.getItem('customerCode');
    //       this.appService.makeHttpGetRequest(url).subscribe(
    //         data => {
    //           if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
    //             if (this.configData.excludedStatus.indexOf(data['searchResult'][0].OB_STATUS_TYPE) > -1) {
    //               this.releaseOrdercall = true;
    //               this.includeStatuscall = false;
    //               this.isLoading = false;
    //               this.normalView();
    //               let modal = new Modal({
    //                 action: false, name: 'Orders', title: "Load Plan Status ", description: "One or more Orders are not in  " + this.configData.includeStatus +
    //                   " status. Please go back to Vehicle Order screen and select again the Orders for Load Planning", actionButtonText: ''
    //               });
    //               this.modalService.createModalBox(modal, data['message'].statusCode);
    //             }
    //             else if (this.includeStatuscall == true && this.configData.includeStatus.indexOf(data['searchResult'][0].OB_STATUS_TYPE) > -1) {
    //               this.includeStatuscall = true;
    //               this.releaseOrdercall = true;
    //             }
    //             else if ((this.releaseOrdercall == false && this.includeStatuscall == false) && this.configData.includeStatus.indexOf(data['searchResult'][0].OB_STATUS_TYPE) > -1) {
    //               this.includeStatuscall = false;
    //               this.releaseOrdercall = false;
    //             }
    //           }
    //         });
    //   });
    //     this.timeout = setTimeout(() => {
    //     if(this.releaseOrdercall == false && this.includeStatuscall == false){
    //       this.releaseOrderCall(orderData)
    //     }
    //    }, 4 * 1000);     
    // }

    // generic submission start

    if(this.configData.header && this.configData.header.action && this.configData.header.action.handler === 'parent'){
      this.isLoading = false;
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        name: this.configData.name,
        action: 'SUBMIT',
        postData: orderData,
        command: data.command,
        actionConfig: data
      })

      // after submitting the button if we are waiting for result on the same page then action button should be disabled
      this.frmGroup.markAsPristine();
      this.frmGroup.markAsUntouched();
    }
    // generic submission end
  }

  releaseOrderCall (orderData){

    //****Only For HD-FV hard Code Customur only*****//
    let customerCode = localStorage.getItem('customerCode');
    let getData = orderData?.table[0]?.poLines;
    let getDataParam = orderData?.param;
    const isCache = this?.configData?.isCache;
    const releaseEntryPath = isCache ? APP_Constants.RELEASE_ORDER_LINK_CACHE : APP_Constants.RELEASE_ORDER_LINK;
    if(customerCode == 'HD-FV' && localStorage.getItem('userRole') == "Vendor"){
      getData.forEach(elm => {
        getDataParam.destination = '';
        getDataParam.edDateLatest = '';
      });
    }
    //****End****//

    this.appService.makeHttpPostRequest(releaseEntryPath + localStorage.getItem('customerCode') + '&userId=' +
    localStorage.getItem('userName'), orderData).subscribe((data) => {
      if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
        this.formError = ''
        let times = 0;
        let transmissionStatus;
        setTimeout(() => {

          const transmissionPath = isCache ? APP_Constants.RELEASE_ORDER_TRANSMISSION_STATUS_CACHE : APP_Constants.RELEASE_ORDER_TRANSMISSION_STATUS;
          this.appService.makeHttpGetRequest(transmissionPath + localStorage.getItem('customerCode') + '&orderId=' +
            data['orderId'] + '&transmissionNo=' + data['transmissionNo'] + '&userId=' + localStorage.getItem('userName'),
          ).subscribe(
            data => {
              console.log(data);
              transmissionStatus = data;
              if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                localStorage.removeItem("selectedPoLines")
                this.router.navigateByUrl('/orders');
                localStorage.removeItem('TotalPoLinesSelected');
                localStorage.removeItem('ResetPoSelected');
                this.isLoading = false;
                this.normalView();
              }

            }, err => {
              this.isLoading = false;
              this.normalView();

              let modal = new Modal({
                action: false, name: 'orderStatus', title: 'Release order status', description: err.message, actionButtonText: ''
              });
              this.modalService.createModalBox(modal, err.status);
              console.log(err);
              return false;
            });

          let intervalId = setInterval(() => {
            if (
              transmissionStatus &&
              (
                transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE
              )) {
              this.isLoading = false;
              this.normalView();
              clearInterval(intervalId);
            } else if (++times == 5 && transmissionStatus && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.IN_PROGRESS_CODE) {
              this.isLoading = false;
              this.normalView();
              this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
              this.router.navigateByUrl('/orders');
              localStorage.removeItem('selectedPoLines');
              localStorage.removeItem("TotalPoLinesSelected")
              localStorage.removeItem('ResetPoSelected');
              clearInterval(intervalId);
            } else {
                        const transmissionPath = isCache ? APP_Constants.RELEASE_ORDER_TRANSMISSION_STATUS_CACHE : APP_Constants.RELEASE_ORDER_TRANSMISSION_STATUS;

              this.appService.makeHttpGetRequest(transmissionPath + localStorage.getItem('customerCode') + '&orderId=' +
                data['orderId'] + '&transmissionNo=' + data['transmissionNo'] + '&userId=' + localStorage.getItem('userName'),
              ).subscribe(
                data => {
                  console.log(data);
                  transmissionStatus = data;
                  if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                    this.isLoading = false;
                    this.normalView();
                    this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                    localStorage.removeItem('selectedPoLines');
                    this.router.navigateByUrl('/orders');
                    localStorage.removeItem('TotalPoLinesSelected');
                    localStorage.removeItem('ResetPoSelected');
                  }
                }, err => {
                  this.isLoading = false;
                  this.normalView();

                  let modal = new Modal({
                    action: false, name: 'orderStatus', title: 'Release order status', description: err.message, actionButtonText: ''
                  });
                  this.modalService.createModalBox(modal, err.status);
                  console.log(err);
                  clearInterval(intervalId);
                  // intervalId = 0;
                });
            }
          }, 3000);
        }, 1000);
      }

      // this.isLoading = false;
      // this.normalView();
    }, (err) => {
      console.log(err);
      this.isLoading = false;
      this.normalView();
      if(err.message == APP_Constants.FAILED_CODE_OVER_RELEASE) {
        let modal = new Modal({
          action: false, name: 'Orders', title: 'Order release', description: "Purchase Order/s cannot be Released because of insufficient Available Quantity", actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      }else {
        let modal = new Modal({
          action: false, name: 'Orders', title: 'Order release', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      }
      this.loadingStatus.emit(this.isLoading);
    })
   }
  normalView() {
    document.getElementById("overlay").style.display = "none";
  }
  backFn(){
    if(this.configData.header.title.redirectUrl){
      this.router.navigateByUrl(this.configData.header.title.redirectUrl);
    }

  }
  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, row = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  formReset(name) {
    this.totalError = 0;
    let details = [];
    this.isDarftGetError = false;
    if(this.configData.header && this.configData.header.action){
      details = this.configData.header.action.details;      
    }
    let event: DhlFormControlEvent | null = this.checkEventExist(details, name);
    if (event) {
      return this.sendToSource(event, this.orderDetails);
    }

    let templatedata = this.configData;

    // localStorage.setItem('mostUsedOriginLocations', '');
    // localStorage.setItem('mostUsedDestinationLocations', '');

    if (this.configData.name == 'releaseOrder') {
      if(this.formFieldFrmGroup?.hasOwnProperty('controls'))
      {
        this.formFieldFrmGroup.reset();
      }
      localStorage.removeItem('poSourceId');
      localStorage.removeItem('poDestId');
      // sessionStorage.removeItem('poLineIdToBeExcluded');
      localStorage.removeItem('qtyRelease');
      localStorage.setItem('releaseFormReset', 'true'); //  need to remove this

      this.appService.resetScrollPaginationData();
    }

    if (this.configData.name === 'releaseOrderViewEdit') {
      this.appService.resetScrollPaginationData();
    }

    if(this.configData.name == 'rateEnquirySearch'){
      let allOptions = this.appService._components['equipment'].configData.options.slice();
      this.appService._components['equipment'].allOptions = allOptions;
      this.appService._components['equipment'].options = [];
      this.appService._components['equipment']?.searcOptionCtrl?.setValue(null);
      let allmodeOptions = this.appService._components['mode'].configData.options.slice();
      this.appService._components['mode'].allOptions = allmodeOptions;
      this.appService._components['mode'].options = [];
      this.appService._components['mode']?.searcOptionCtrl?.setValue(null);
      // exception columns can be fetched from template
      
      let controlsArr = this.formService.getFormControl(this.frmGroup, ["originGeoPoints", "destinationGeoPoints", "earlyPuDate", "earlyDlDate","freightClass","quantity","volume","weight"]);
     
      localStorage.setItem('originLocationAddressToSearch', '');
      localStorage.setItem('originMapUrl', '');

      localStorage.setItem('destLocationAddressToSearch', '');
      localStorage.setItem('destMapUrl', '');
      this.frmGroup.reset();
      controlsArr.forEach(Ctrl => {
      let component = this.appService._components[Ctrl.name].configData;
      let control = Ctrl.control;
      if (component.component == 'DATEPICKER') {
        // this.appService._components['earlyPuDate'].configData
          control['maxDate'] = null;
          component.validation.forEach(check => {
            let validationCheck = check.split('-');
            if(Object.values(component.defaultValue).length){
              control.setValue(new Date(component.defaultValue.value));
            }
            if (validationCheck[0] === 'before') {
              control['minDate'] = new Date(new Date().toDateString());
            }
            if (validationCheck[0] === 'after') {
              control['minDate'] = new Date(this.formService.getFormControl(this.frmGroup, [validationCheck[1]])[0].control.value);
            }
          });
        } else if (component.component == 'DROPDOWN') {
          this.configData.configs.relatedColumns.forEach(cols => {
            // if (control.value && control.value.value == cols.key) {
            cols.value.forEach(col => {
              this.appService._components[col].configData.visibility = "hidden";
              this.appService._components[col].configData.required = false;
              this.appService._components[col].frmGroup.get(col).setErrors(null);
              this.appService._components[col].frmGroup.get(col).updateValueAndValidity();
            });
            // }
          });
        }
      }, this);
      return
    }
    if (name === 'discard') {

      this.frmGroup = this.formService.createOrderFormToViewAndEdit(this.frmGroup, this.configData, this.orderDetails);
      if (this.configData.name === 'selfConfig_BE_ParentXML') {
        this.frmGroup.patchValue(this.orderDetails);
      } else
      this.frmGroup.patchValue(this.orderDetails.value);
      setTimeout(()=>{
        // this.frmGroup.patchValue(this.orderDetails.value);
      }, 200)
      if (templatedata && templatedata.groups) {
      templatedata.groups.forEach(group => {
        group.controls.forEach((data, index) => {
          if (Array.isArray(data.controls) && data.controls.length) {
            var name = data.name;
            var component = data.component;
            if (this.frmGroup.get(name)['controls'].length && component === 'CARD') {
              this.frmGroup.get(name)['shipmentList'] = this.frmGroup.get(name).value;
            }

            if (this.frmGroup.get(name)['controls'].length) {

              data.controls.forEach((field, ind) => {
                if (field.component == 'DATEPICKER') {

                  this.frmGroup.get(name)['controls'][index].get(field.name).reset();
                  this.frmGroup.get(name)['controls'][index].get(field.name)['maxDate'] = null;

                  if (this.frmGroup.get(name)['controls'][index].get(field.name) != '')
                    this.frmGroup.get(name)['controls'][index].get(field.name).setValue(new Date(this.orderDetails.value[field.name]));

                  // if(+ new Date(this.frmGroup.get(name)['controls'][index].get(field.name).value) > +new Date(new Date().toDateString())){
                  field.validation.forEach(check => {
                    let validationCheck = check.split('-');
                    if (validationCheck[0] === 'before') {
                      this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(new Date().toDateString());
                    }
                    if (validationCheck[0] === 'after') {
                      this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(this.frmGroup.get(name)['controls'][index].get(validationCheck[1]).value);
                    }
                  })
                  // } else{
                  // this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(new Date().toDateString());
                  // }
                }else if(field.component == 'DROPDOWN_DEFAULT_V2'){
                  let value = this.frmGroup.get(name).value.value || this.frmGroup.get(name).value;
                  this.appService._components[field.name].selectedOption(value, true);
                }
                else if (field.component == 'TOGGLESWITCH_V2') {
                  if(this.appService._components[field.name]){
                    this.appService._components[field.name].onReset();
                  }
                }
              }, this)
            }

          } else {
            if (data.component == 'DATEPICKER') {
              this.frmGroup.get(data.name)['maxDate'] = null;

              // if(+ new Date(this.frmGroup.get(data.name).value) > +new Date(new Date().toDateString())){
              data.validation.forEach(check => {
                let validationCheck = check.split('-');
                if (validationCheck[0] === 'before') {
                  this.frmGroup.get(data.name)['minDate'] = new Date(new Date().toDateString());
                }
                if (validationCheck[0] === 'after') {
                  this.frmGroup.get(data.name)['minDate'] = new Date(this.frmGroup.get(validationCheck[1]).value);
                }
              })
              // } else{
              //   this.frmGroup.get(data.name)['minDate'] = new Date(new Date().toDateString());
              // }
              if (this.orderDetails.value[data.name] != '')
                this.frmGroup.get(data.name).setValue(new Date(this.orderDetails.value[data.name]));
            }else if(data.component == 'DROPDOWN_DEFAULT_V2'){
              let value = this.frmGroup.get(data.name).value.value || this.frmGroup.get(data.name).value;
              this.appService._components[data.name].selectedOption(value, true);
            }else if (data.component == 'TOGGLESWITCH_V2') {
              if(this.appService._components[data.name]){
                this.appService._components[data.name].onReset();
              }
            } else if (data.component == 'GENERIC_AUTOCOMPLETE_V2') {
              if (this.frmGroup.controls[data.name].value && this.frmGroup.controls[data.name].value !== '') {
                this.frmGroup.controls[data.name]['itemArray'].push(this.frmGroup.controls[data.name].value)
              }
            } else if (data.component == 'DATEPICKER_V2' && data.dateValidation !== undefined) {
              let values = this.frmGroup.get(data.name)?.value
              if (values && values?.length > 0) {
                setTimeout(() => {
                  this.appService.compareTwoDates('', data, this.frmGroup);
                }, 100)
              };
            }
          }
          
          let frmControl = this.frmGroup.get(data.name);
          if (data?.component === 'DROPDOWN_SIMPLE_V2' && !frmControl?.value && !frmControl["hidden"] && data?.events?.length > 0) {
            this.appService._components[data?.name]?.onCommonEventHander('SELECTED_VALUE', null);
          }
        }, this)
      }, this);
      if(!this.orderDetails.skipSecondary || this.orderDetails.skipSecondary === undefined){
        this.formService.setSecondaryTextFormField(this.orderDetails, this.frmGroup);
      }

      this.frmGroup.markAsPristine();
      this.frmGroup.markAsUntouched();

      return;
    }
    }

    localStorage.setItem('originLocationAddressToSearch', '');
    localStorage.setItem('originMapUrl', '');

    localStorage.setItem('destLocationAddressToSearch', '');
    localStorage.setItem('destMapUrl', '');
    this.frmGroup.reset();

    if (templatedata) {
      if (templatedata['sections']) {
        if (Array.isArray(templatedata['sections']) && templatedata['sections'].length) {
          templatedata['sections'].forEach((element, j) => {

          console.log(this.frmGroup)
          element.groups.forEach((group, i) => {

          group.controls.forEach((elem, index) => {
            console.log(elem);
            if (elem.component == 'DROPDOWN_DEFAULT_V2') {
              this.appService._components[`${elem.name}`].reset();
              if(this.appService._components[`${elem.name}`]){
                const defaultValueObj = this.appService._components[`${elem.name}`].configData.defaultValue;
                const defVal = (defaultValueObj && typeof defaultValueObj === 'object' && 'value' in defaultValueObj) ? defaultValueObj.value : defaultValueObj;
                this.appService._components[`${elem.name}`].selectedOption(defVal, true);
              }
            }

            else if (elem.component == 'DATEPICKER_V2') {
              this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name].reset();
              this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name]['maxDate'] = null;
              this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name]['minDate'] = new Date(new Date().toDateString());
              if (elem.defaultValue) {
                const defaultDate = (elem.defaultValue && typeof elem.defaultValue === 'object' && elem.defaultValue.displayValue) ? elem.defaultValue.displayValue : elem.defaultValue;
                this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name].setValue(new Date(defaultDate));
              }else if (elem.component == 'TOGGLESWITCH_V2') {
                if(this.appService._components[elem.name]){
                  this.appService._components[elem.name].onReset();
                }
              }
            }
            else if(elem.component == 'TABLE_V2'){
              elem.controls.forEach(elements => {
                if (elements.component == 'DROPDOWN_DEFAULT_V2'){
                  this.appService._components[`${elements.name}`].reset();
              if(this.appService._components[`${elements.name}`]){
                const defaultValueObj = this.appService._components[`${elements.name}`].configData.defaultValue;
                const defVal = (defaultValueObj && typeof defaultValueObj === 'object' && 'value' in defaultValueObj) ? defaultValueObj.value : defaultValueObj;
                this.appService._components[`${elements.name}`].selectedOption(defVal, true);
              }
                }
                
              });
            }
            
            });
          }, this);
          });
        }
      }
      else {
      templatedata.groups.forEach(group => {
        group.controls.forEach((data, index) => {
          if ((Array.isArray(data.controls) && data.controls.length) || (Array.isArray(data.tabs) && data.tabs.length)) { //CP-9901
            var name = data.name;
            if (data.validation) {
              this.frmGroup.get(data.name) &&  data.validation.forEach(check => {
                if (check == 'ZeroOrMoreLines') {
                  this.frmGroup.get(data.name)['controls'].splice(1, this.frmGroup.get(data.name)['controls'].length);
                  this.frmGroup.get(data.name).reset();
                } else if (check == 'OneOrMoreLines') {
                  this.frmGroup.get(data.name).reset();
                  if (this.frmGroup.get(data.name)['controls'][0]) {
                    Object.keys(this.frmGroup.get(data.name)['controls'][0]['controls']).forEach(element => {
                      if (this.appService._components[element]?.configData?.component == "DROPDOWN_DEFAULT_V2") {
                        this.appService._components[element].reset()
                      }
                      if (this.appService._components[element]?.configData?.component == "GENERIC_AUTOCOMPLETE_V2") {
                        this.appService._components[element].isResetting = true;
                      }
                    })
                    this.frmGroup.get(data.name)['controls'][0]['secondaryText'] = '';
                    this.frmGroup.get(data.name)['controls'][0]['itemArray'] = [];
                  }

                  this.frmGroup.get(data.name)['controls'].splice(0, this.frmGroup.get(data.name)['controls'].length - 1);
                  this.frmGroup.get(data.name)['controls']['deleteButton'] = false;
                  this.frmGroup.get(data.name)['shipmentList'] = [];
                  setTimeout(() => {
                    const firstLineItem = this.frmGroup.get(data.name)['controls'][0];
                    if (firstLineItem) {
                      data.controls.forEach(field => {
                        if (field.component === 'GENERIC_AUTOCOMPLETE_V2') {
                          const ctrl = firstLineItem.get(field.name);
                          if (ctrl && ctrl.value && ctrl.value !== '') {
                            if (!Array.isArray(ctrl['itemArray'])) ctrl['itemArray'] = [];
                            if (ctrl['itemArray'].indexOf(ctrl.value) < 0) {
                              ctrl['itemArray'].push(ctrl.value);
                            }
                            ctrl.setErrors(null);
                          }
                          if (this.appService._components[field.name]) {
                            this.appService._components[field.name].isResetting = false;
                          }
                        }
                      });
                    }
                  }, 0);
                }
                else {
                  if (this.frmGroup.get(name)['controls'].length) {
                    let ctrls = data.controls || data.tabs; //CP-9901
                    ctrls.forEach((field, ind) => {
                      if (!Object.keys(field.defaultValue).length) {
                        this.frmGroup.get(name)['controls'][index].get(field.name).reset();

                      } else {
                        if (data.component == 'DATEPICKER') {
                          this.frmGroup.get(name)['controls'][index].get(field.name).reset();
                          this.frmGroup.get(name)['controls'][index].get(field.name)['maxDate'] = null;
                          this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(new Date().toDateString());
                          this.frmGroup.get(name)['controls'][index].get(field.name).setValue(new Date(data.defaultValue.displayValue));
                        } else {
                          if (this.frmGroup.get(name)['controls'][index]) {
                            this.frmGroup.get(name)['controls'][index].get(field.name).setValue(this.formService.fetchValueFromDefaultValue(field)); //CP-9901
                          }
                          else {
                            this.frmGroup.get(name)['controls'][0].get(field.name).setValue(this.formService.fetchValueFromDefaultValue(field)); //CP-9901
                          }
                        }
                      }
                    }, this)
                  }
                }
              }, this)
            }
          }
          else {
            if (!Object.keys(data?.defaultValue).length) {
              this.frmGroup.get(data.name).reset();
              this.frmGroup.get(data.name)['secondaryText'] = '';
              this.frmGroup.get(data.name)['locationArray'] = [];
              this.appService.newEvent({ 'location': 'reset' });

              //CP-4363 RESET Autocomplete 'ItemArray' value with blank array/default value.
              if (data.component === "GENERIC_AUTOCOMPLETE_V2"){
                let defVal =  data.defaultValue[0] || data.defaultValue;
                this.frmGroup.get(data.name).setValue(defVal);
                if(defVal){
                  this.frmGroup.get(data.name)['itemArray'].push(defVal);
                } else {
                  this.frmGroup.get(data.name)['itemArray'] = [];
                }
              }
            }
            else {
              if (data.component == 'DATEPICKER') {
                this.frmGroup.get(data.name).reset();
                this.frmGroup.get(data.name)['maxDate'] = null;
                this.frmGroup.get(data.name)['minDate'] = new Date(new Date().toDateString());
                this.frmGroup.get(data.name).setValue(new Date(data.defaultValue.displayValue));
              }
              else if (data.component == 'DROPDOWN_DEFAULT_V2') {
                this.frmGroup.get(data.name).reset();
                if(this.appService._components[data.name]){
                  const defaultValueObj = this.appService._components[data.name].configData.defaultValue;
                  const defVal = (defaultValueObj && typeof defaultValueObj === 'object' && 'value' in defaultValueObj) ? defaultValueObj.value : defaultValueObj;
                  this.appService._components[data.name].selectedOption(defVal, true);
                }
                this.appService._components[data.name].reset();
              }
              else if (data.component == 'TOGGLESWITCH_V2') {
                if(this.appService._components[data.name]){
                  this.appService._components[data.name].onReset();
                }
              }
              else if(data.component == 'FILEUPLOAD') {
                if(this.appService._components[data.name]){
                  this.appService._components[data.name].frmGroup.get(data.name).disable();
                  this.appService._components[data.name].onReset();
                }
              }
              else if (data.component == 'RADIOBUTTON_V2') {
                if(this.appService._components[data.name]){
                  this.appService._components[data.name].onReset();
                }
              }
              else if (data.component == 'WRAPPER') {
                //This extension its added to avoid no component Error in the Reset process
                console.log(data);
              }
              else {
                if (this.frmGroup.get(data.name)) {
                  this.frmGroup.get(data.name).setValue(this.formService.fetchValueFromDefaultValue(data)); //CP-9901
                }
              }
              if(templatedata.header.single_order_create_screen){
                if(group.label === 'Staging Location Details'){
                  group.visibility=false;
                }
                if(data.component === 'GENERIC_FIELD_V2' && data.label==='Associated Order Number'){
                  this.appService._components[data.name].toggleVisibility(true,false);
                }
              }
            }
            // Default show/hide value assign to warning message component
            if (data.warningText) {
              data.warningText.showText = data.warningText.showDefaultText;
            }
          }
        }, this)
      }, this);
    }
    if (templatedata.name === 'releaseOrderWithStatus'){
      let selectedPoLine = localStorage.getItem("ResetPoSelected");
      if (selectedPoLine){
        localStorage.setItem("TotalPoLinesSelected",selectedPoLine);
        document.getElementById('poSelectCount').innerHTML = selectedPoLine;
      }else{
        let resetPoLine = "1";
        localStorage.setItem("TotalPoLinesSelected",resetPoLine);
        document.getElementById('poSelectCount').innerHTML = resetPoLine;
      }
    }
    }
    // discard functionality for order update

    if(name && name.type === "discard"){
      let obj = this.orderDetails;
      this.totalError = 0;
      if (obj !== undefined && obj !== null && obj.value !== undefined && obj.value !== null) {
            this.frmGroup.patchValue(obj.value);
          if(obj.validateField){
            this.validateAllFormFields(this.frmGroup);
          }
      }
       // this.form.emit(this.frmGroup);
    }

    //CP-2434 :start : date format changes on discard or reset---fixed
    if (this.configData.sections) {
      this.configData.sections.forEach((section, i) => {
        section.groups.forEach((groups, j) => {
          groups.controls.forEach((control, k) => {
            if (control.component == "DATEPICKER_V2" && control.dataType == 'OBJECT' && this.frmGroup.get(section.name)['controls'][0].get(control.name).value
              && typeof this.frmGroup.get(section.name)['controls'][0].get(control.name).value == 'string') {
              let obj = {};
              try {
                let val = this.frmGroup.get(section.name)['controls'][0].get(control.name).value;
                obj['displayValue'] = this.appService.getSystemDateMMddyyyy(val);

                if(val.length >10){
                  obj['value'] = val;
                }
                else{
                  obj['value'] = new Date(this.appService.formatDateForExportDatepicker(val)).toISOString().slice(0, -1);
                }
              }
              catch (e) {
                obj['displayValue'] = this.frmGroup.get(section.name)['controls'][0].get(control.name).value;
                obj['value'] = this.frmGroup.get(section.name)['controls'][0].get(control.name).value;
              }
              this.frmGroup.get(section.name)['controls'][0].get(control.name).setValue(obj);
            }
            this.formResetAndSetVal(control);
            if (this?.configData?.payloadFormat === 'DYNAMIC_ACCORDION') {
              if (control?.component === 'TABLE_V2') {
                const controlConfigs = this.formService.extractFieldNamesFromConfig(control);
                controlConfigs?.forEach(ctrl => {
                  this.formService.handleValidationOnReset(this.configData, '', '', ctrl);
                });
              } else {
                this.formService.handleValidationOnReset(this.configData, '', '', control);
              }
            }
          });
        });
      });
    }
    else {
      this.configData.groups.forEach((groups, j) => {
        groups.controls.forEach((control, k) => {
          if (control.component == "DATEPICKER_V2" && control.dataType == 'OBJECT' && this.frmGroup.get(control.name).value
            && typeof this.frmGroup.get(control.name).value == 'string') {
            let obj = {};
            try {
              let val = this.frmGroup.get(control.name).value;
              obj['displayValue'] = this.appService.getSystemDateMMddyyyy(val);

              if(val.length >10){
                obj['value'] = val;
              }
              else{
                obj['value'] = new Date(this.appService.formatDateForExportDatepicker(val)).toISOString().slice(0, -1);
              }
            }
            catch (e) {
              obj['displayValue'] = this.frmGroup.get(control.name).value;
              obj['value'] = this.frmGroup.get(control.name).value;
            }
            this.frmGroup.get(control.name).setValue(obj);
          }
          this.formResetAndSetVal(control);
        });
      });
    }//CP:2434 : end

    // =================== GENERIC RESET START =====================================

    if (this.configData.header && this.configData.header.action && this.configData.header.action.handler === 'parent') {

      if(this.configData.schemaValidation){
        // ------------- START OF RESET FOR NEW SCHEMA VALIDATED TEMPLATES -------------------------
        this.frmGroup.reset();
        this.setValueForAnyTemplate();
        // Copy Order: form was repopulated with the copied data, so action buttons should depend only on form validity
        if (this.orderDetails?.rawData) {
          this.frmGroup.markAllAsTouched();
        }
        this.appService._commonComponentSubject.next({
          configData: this.configData,
          name: this.configData.name,
          action: 'RESET'
        })
        // ------------- END OF RESET FOR NEW SCHEMA VALIDATED TEMPLATES -------------------------
      } else {
        let that = this;
        if (this.configData.sections) {
          this.configData.sections.forEach((a, i) => {
            a.groups.forEach((b, j) => {
              b.controls.forEach((c, k) => {
                if (c.defaultValue && c.defaultValue !== undefined) {
                  if (!(Object.keys(c.defaultValue).length === 0 && c.defaultValue.constructor === Object) && c.defaultValue) {
                    that.frmGroup.get(a.name)['controls'][0].get(c.name).setValue(c.defaultValue);
                  }
                }
                //RESET Autocomplete 'ItemArray' value with default value to remove error "Please Select from list".
                if (c.component === 'GENERIC_AUTOCOMPLETE_V2') {
                  let defVal = c.defaultValue[0] || c.defaultValue;
                  this.frmGroup.get(a.name)['controls'][0].get(c.name).setValue(defVal);
                  if (defVal) {
                    that.frmGroup.get(a.name)['controls'][0].get(c.name)['itemArray'].push(defVal);
                  } else {
                    that.frmGroup.get(a.name)['controls'][0].get(c.name)['itemArray'] = [];
                  }
                }
              })
            })
          })
        }

        let obj = this.orderDetails;
        if (obj !== undefined && obj !== null && obj.value !== undefined && obj.value !== null ) {
          this.frmGroup.patchValue(obj.value);
          if (obj.validateField) {
            this.validateAllFormFields(this.frmGroup);
          }
        }

        // discard functionality for order verify
        if (name === 'orderReset') {
          let obj = this.multipleOrderDetails;
          if (obj && obj !== undefined) {
            this.frmGroup.patchValue(this.multipleOrderDetails);
            if (obj.validateField) {
              this.validateAllFormFields(this.frmGroup);
            }
          }
        }

        this.appService._commonComponentSubject.next({
          configData: this.configData,
          name: this.configData.name,
          action: 'RESET'
        })
      }


    }
    // =================== GENERIC RESET END =====================================
    this.alphaService.clearGroupValidationErrors({
      validations: this.configData.groupValidations,
      formGroup: this.frmGroup,
    });
    this.alphaService.executeGroupValidations({
      validations: this.configData.groupValidations,
      formGroup: this.frmGroup,
      shouldValidate: false,
      shouldSubscribe: true,
    });
  }

  setValueForAnyTemplate(){
    let groupControls = [];
        if (this?.configData?.payloadFormat === 'DYNAMIC_ACCORDION') {
          const draftMode = localStorage.getItem('filterCurrenturl')?.includes('draft');
          const patchData = draftMode ? this.orderDetails?.value : this.orderDetails?.data?.businessObject;
          if (patchData) {
            this.formService.patchingValueForViewEdit(this.frmGroup, this.configData, patchData);
          }
          return;
        }
        if(this.configData.sections){
          this.configData.sections.forEach((section, sectionIndex)=>{
            section.groups.forEach((group, groupIndex)=>{
              group.controls.forEach((control, controlIndex)=>{
                groupControls.push({'control': control, 'section': section.name});
              });
            });
          });
        } else if(this.configData.groups){
          this.configData.groups.forEach((group, groupIndex)=>{
            group.controls.forEach((control, controlIndex)=>{
              groupControls.push({'control': control, 'section': null});
            });
          });
        }
        if(groupControls.length){
          groupControls.forEach((controlData, controlIndex)=>{
            if(controlData.control.defaultValue){
              let value = (this.orderDetails && this.orderDetails?.rawData) ? this.orderDetails.rawData[controlData.control.name] : null;
              if((value === undefined || value === null) && controlData?.control?.formType !== 'FORM_ARRAY'){
                value = this.formService.fetchValueFromDefaultValue(controlData.control);
              }
              let frmControl;
              if(controlData.section){
                frmControl = this.frmGroup.get(controlData.section)['controls'][0].get(controlData.control.name);
              } else{
                frmControl = this.frmGroup.get(controlData.control.name);
              } 

              if (controlData.control.formType === 'FORM_ARRAY') {
                if (value === undefined || value === null) {
                  frmControl.controls.splice(0,frmControl.controls.length);
                  frmControl.controls.deleteButton = false;
                  let tempForm = this.formService.simpleFormCreation(controlData.control);
                  (<UntypedFormArray>frmControl).push(tempForm.controls[0]);
                  let ctrls = controlData.control.controls || controlData.control.tabs; //CP-9901
                  ctrls.forEach((innerCtrl) => {
                    for (let i = 0; i < frmControl['controls'].length; i++) {
                      const innerFormGrp = frmControl['controls'][i].get(innerCtrl.name);
                      if (innerFormGrp && !(innerFormGrp instanceof UntypedFormArray)) {
                        innerFormGrp.patchValue(this.formService.fetchValueFromDefaultValue(innerCtrl));
                      }
                    }
                  });
                } else {
                  if (frmControl) {
                    let length;
                    if (value.length > frmControl.controls.length) {
                      length = value.length - frmControl.controls.length;
                      for (let i = 0; i < length; i++) {
                        let tempForm = this.formService.simpleFormCreation(controlData.control);
                        (<UntypedFormArray>frmControl).push(tempForm.controls[0]);
                      }
                    } else {
                      length = frmControl.controls.length - value.length;
                      for (let i = 0; i < length; i++) {
                        frmControl.controls.pop();
                      }
                    }
                    frmControl.controls.deleteButton = true;
                    frmControl.patchValue(value);

                    let ctrls = controlData.control.controls || controlData.control.tabs; //CP-9901
                    if (ctrls) {
                      ctrls.forEach((innerCtrl) => {
                        const innerFormGrp = frmControl['controls'][0] ? frmControl['controls'][0].get(innerCtrl.name) : null;
                        if (innerCtrl.component == "ORDER_ITEM_AUTOCOMPLETE_V2" && (innerFormGrp.value! == null || innerFormGrp.value !== undefined)) {
                          innerFormGrp['itemArray'].push(innerFormGrp.value);
                        }
                        if (innerCtrl.component === "CHIPSAUTOCOMPLETE") {
                          this.appService._components[innerCtrl?.name].setDefaultValueOnReset();
                        }
                        if (innerCtrl.component === "PO_ITEM_AUTOCOMPLETE_V2" && !innerFormGrp['itemArray'].includes(innerFormGrp.value)) {
                          innerFormGrp['itemArray'].push(innerFormGrp.value);
                          this.formService.setSecondaryTextFormField(this.orderDetails, this.frmGroup);
                        }
                        if (innerCtrl.component === "TOGGLESWITCH_V2" && innerCtrl.setValueOnToggleChange && innerCtrl['multiAffectedColumns']) {
                          this.appService._components[innerCtrl?.name]?.onCommonEventHander('TOGGLE', 'INITIAL');
                        }
                      })
                    }

                    if (controlData.control.name === 'poLines' && frmControl?.controls[0]["secondaryText"] === "" && this.orderDetails?.rawData?.poLines) {
                      let poLineSecondaryText = {},
                        data = this.orderDetails.rawData.poLines[0];
                      poLineSecondaryText["source"] = data['shipFromId'] + ',' + data['shipFromName'] || '';
                      poLineSecondaryText["destination"] = data['shipToId'] + ',' + data['shipToName'] || '';
                      poLineSecondaryText["seperator"] = 'arrow_right_alt';
                      frmControl.controls[0]["secondaryText"] = poLineSecondaryText;
                    }
                    // start-Reset date value with existing field value/dynamicDefaultValue
                    if (controlData.control.tabs && controlData.control.tabs.length) {
                      controlData.control.tabs.forEach((tab, index) => {
                        tab['groups'] && tab['groups'].forEach((group) => {
                          group['controls'] && group['controls'].forEach((ctrl) => {
                            if (ctrl.component === 'DATEPICKER_V2') {
                              let currentDate = new Date();
                              let result = ctrl.dynamicDefaultValue ? currentDate.setDate(currentDate.getDate() + parseInt(ctrl.dynamicDefaultValue.split("+")[1])) : null;
                              let date_value = this.orderDetails ? this.orderDetails.rawData[controlData.control.name][index] : null;
                              if (result && (date_value[ctrl.name] === "" || date_value[ctrl.name] === undefined || date_value[ctrl.name] === null)) {
                                frmControl.controls[index].controls[ctrl.name].patchValue(this.appService.formatDateValueForCox(ctrl, new Date(result).toISOString().slice(0, -1)));
                              } else {
                                frmControl.controls[index].controls[ctrl.name].patchValue(this.appService.formatDateValueForCox(ctrl, date_value[ctrl.name]));
                              }
                            }
                          })
                        })
                      })
                    }
                    // end
                  }
                }    
              } else {
                if (frmControl) {
                  frmControl.patchValue(value);
                }
              }

              // if (controlData.control.formType === 'FORM_ARRAY') {
              //   controlData.control.controls.forEach((innerCtrl) => {
              //     const innerFormGrp = frmControl['controls'][0].get(innerCtrl.name);
              //     if (innerFormGrp && !(innerFormGrp instanceof FormArray)) {
              //       let innerValue = this.orderDetails?.rawData[controlData.control.name] || null;
              //       if(innerValue === undefined || innerValue === null){
              //         innerValue = this.formService.fetchValueFromDefaultValue(innerCtrl);
              //       }
              //       innerFormGrp.patchValue(innerValue);
              //     }
              //   });
              // } else {
              //  frmControl.patchValue(value);
              // }
              //--------RESET Autocomplete 'ItemArray' value with default value to remove error "Please Select from list".
              if (controlData.control.component === 'GENERIC_AUTOCOMPLETE_V2') {
                if(value === null || value === undefined){
                  frmControl['itemArray'] = [];
                } else {
                  if (frmControl['itemArray']) {
                    frmControl['itemArray'].push(value); 
                  }
                  else {
                    let arr = []
                    arr.push(value)
                    frmControl['itemArray'] = arr;
                  }
                }
                if(this.appService._components[controlData.control.name]){
                  this.appService._components[controlData.control.name].resetAutocompleteFieldValue();
                }
              } 
              //Portalna-8499 observation Reset Issue for Premium freight Toggle fixed
              if (controlData?.control?.component === "TOGGLESWITCH_V2" && this.appService?._components?.[controlData.control?.name]) {
                this.appService._components[controlData.control?.name].onReset();
              } 
              // --------RESET Autocomplete

              // Attribute 'dynamicDefaultValue' To use dynamic defalut value for calendar. for e.g. set default value as date+10
              if (controlData.control.component === 'DATEPICKER_V2' && (controlData?.control?.dynamicDefaultValue !== undefined || controlData?.control?.dynamicDefaultValue !== null) ) {
                let currentDate = new Date();
                let result = currentDate.setDate(currentDate.getDate() + parseInt(controlData.control?.dynamicDefaultValue?.split("+")[1]));        
                let date_value = this.orderDetails ? this.orderDetails.rawData[controlData.control.name] : null;
                if((date_value === undefined || date_value === null ) && result){
                  frmControl.patchValue(this.appService.formatDateValueForCox(controlData.control, new Date(result).toISOString().slice(0, -1)));
                } else {
                  frmControl.patchValue(this.appService.formatDateValueForCox(controlData.control, date_value));
                }              
              } // END - dynamicDefaultValue 
              
              if(controlData.control.component === 'LOCATION_AUTOCOMPLETE_V2') {
                let data = this.orderDetails;
                if(frmControl['secondaryText'] === "" && (controlData.control.type === "SOURCE" || controlData.control.type === "ORIGIN") && data)
                  frmControl['secondaryText'] = data?.sourceLocationAddressLine + "," + data?.sourceLocationCity + ',' + data?.sourceLocationProvinceCode + ',' + data?.sourceLocationPostalCode;
                else if(frmControl['secondaryText'] === "" && controlData.control.type === "DESTINATION" && data)
                  frmControl['secondaryText'] = data?.destinationLocationAddressLine + "," + data?.destinationLocationCity + ',' + data?.destinationLocationProvinceCode + ',' + data?.destinationLocationPostalCode;
                  
                if(frmControl.value && !frmControl['itemArray'].includes(frmControl.value)) 
                  frmControl['itemArray'].push(frmControl.value);

                if (!frmControl?.hidden && controlData?.control?.events?.length > 0) {
                  if (!value) {
                    this.appService.setDestinationUsedLocation('');
                    this.appService.setOriginUsedLocation('');
                    this.appService._components[controlData.control.name]?.onCommonEventHander('VALIDATE_WHEN_AUTOCOMPLETE_SELECTED', null);
                  } else {
                    this.alphaService.setLocationDraftOrder(data);
                    this.appService._components[controlData.control.name]?.setDefaultValueOnReset();
                  }
                }
              }

              if (controlData?.control?.component === 'DROPDOWN_SIMPLE_V2') {
                this.appService._components[controlData.control?.name]?.onCommonEventHander('SELECTED_VALUE', null);
              }

              if (controlData.control.component === 'DATEPICKER_V2' && controlData?.control?.dateValidation) {
                this.appService._components[controlData.control.name]?.setDefaultValueInDateFn();
              }

              if (controlData?.control?.component === "CHIPSAUTOCOMPLETE") {
                this.appService._components[controlData.control?.name].setDefaultValueOnReset();
              }
              if (controlData?.control?.component === 'HIDDEN' && controlData?.control?.revalidateDependentField) {
                this.appService?._components?.[controlData.control.revalidateDependentField]?.validateLocationIsActive();
              }
            }
          });
        }
  }
  //Reset some fields for dynamic validationn
  formResetAndSetVal = (control) => {
    if (control && control.controls) {
      const itemControls = <UntypedFormArray>this.frmGroup.get(control.name);
      const itemFormGroup = itemControls && <UntypedFormGroup>itemControls.controls[0];
      itemFormGroup && control.controls.forEach(elm => {
        if (elm.groupValidation) {
          const formGroupData = itemFormGroup.get(elm.name);
          formGroupData['isRequired'] = false; // this key is use for '*' mark show/hide
          formGroupData.setValidators([Validators.required]);
          formGroupData.updateValueAndValidity();
          formGroupData.reset();
        }
      });
    }
    else {
      if (control.groupValidation) {
        const formGroupData = this.frmGroup.get(control.name);
        formGroupData['isRequired'] = false; // this key is use for '*' mark show/hide
        formGroupData.setValidators([Validators.required]);
        formGroupData.updateValueAndValidity();
        formGroupData.reset();
      }
    }
  }

  addNewFeatures(formGroup, features) {
    features.forEach(feature => {
      if (feature.type === 'storage') {
        let storage = feature.storageDetails;
        let databaseStorage = feature.database;
        let value = [];
        if (storage) {
          storage.forEach(element => {
            let list = JSON.parse(localStorage.getItem(element.field.name));
            if (element.field.formField === 'origin') {
              let location = this.appService.getOriginUsedLocation();
              let present = false;
              if (list && location) {
                list.forEach(a => {
                  if (a.locationId === location.locationId) {
                    present = true;
                  }
                })
                if (!present) {
                  list.push(location);
                }
                value = list;
              } else {
                value.push(this.appService.getOriginUsedLocation());
              }
              let url = APP_Constants.USER_PREFERENCE_URL + localStorage.getItem('userName') + '&customerCode=' +
                localStorage.getItem('customerCode') + '&preferenceType=' + element.field.preferenceType + '&action=' + feature.action;

              this.appService.makeHttpPostRequest(url, value).subscribe(data => {
                console.log(data);
              }, err => {
                console.log(err);
              });
            }
            if (element.field.formField === 'destination') {
              let location = this.appService.getDestinationUsedLocation();
              let present = false;
              if (list && location) {
                list.forEach(a => {
                  if (a.locationId === location.locationId) {
                    present = true;
                  }
                })
                if (!present) {
                  list.push(location);
                }
                value = list;
              } else {
                value.push(this.appService.getDestinationUsedLocation());
              }
              let url = APP_Constants.USER_PREFERENCE_URL + localStorage.getItem('userName') + '&customerCode=' +
                localStorage.getItem('customerCode') + '&preferenceType=' + element.field.preferenceType + '&action=' + feature.action;

              this.appService.makeHttpPostRequest(url, value).subscribe(data => {
                console.log(data);
              }, err => {
                console.log(err);
              });
            }
            if (element.field.type === 'LOCALSTORAGE') {
              localStorage.setItem(element.field.name, JSON.stringify(value));
            } else if (element.type === 'SESSIONSTORAGE') {
              localStorage.setItem(element.field.name, JSON.stringify(value));
            }
            value = [];
          });
        }

        // if (databaseStorage) {
        //   databaseStorage.forEach(element=>{
        //     if (element.field.formField === 'destination') {
        //       let url = APP_Constants.USER_PREFERENCE_URL + sessionStorage.getItem('userName') + '&customerCode=' +
        //       sessionStorage.getItem('customerCode') + '&preferenceType=' + element.field.preferenceType + '&action=' + element.field.action;

        //       this.appService.makeHttpPostRequest(APP_Constants.USER_PREFERENCE_URL,{}).subscribe(data=>{
        //         console.log(data);
        //       }, err=>{
        //         console.log(err);
        //       });
        //     }
        //   })
        // }
      }
    })
  }

  makeApiCall(postUrl, transmissionUrl, redirectUrl, orderData, method, modalDetails) {
    let postData;

    if (method === 'UPLOAD') {
      postData = orderData.param;
      const formData: FormData = new FormData();
      let fileData = this.appService.getUploadFileData();
      if (fileData) {
        if (Array.isArray(fileData) || fileData instanceof FileList) {
          Array.from(fileData).forEach((f: File) => formData.append('file', f, f.name));
        } else {
          formData.append('file', fileData, fileData.name);
        }
      }
      formData.append('requestData', JSON.stringify(postData));
      postData = formData;
    } else {
      postData = orderData
    }


    this.appService.makeHttpPostRequest(postUrl, postData).subscribe(response => {
      if (modalDetails.name === 'customer') {
        this.isLoading = false;
        this.normalView();
        // this.appService.
        this._snackBar.open( { message: 'Customer onboarded !', orderId: "" }, { duration: this.durationInSeconds * 1000 });
        this.router.navigateByUrl('/profile');
        this.router.navigateByUrl('/cutomer/status');
      } else {
        let rateEnquiry = { ...postData.param }
        // rateEnquiryResult = postData.param;
        rateEnquiry['mode'] = this.frmGroup.value.mode;
        rateEnquiry['equipment'] = this.frmGroup.value.equipment;

        console.log(response);
        this.isLoading = false;
        this.normalView();

        this.appService.setRateLookupResult(response);

        if (redirectUrl !== null && redirectUrl !== "") {
          console.log(JSON.stringify(rateEnquiry));
          this.appService.setRateLookupEnquiry(rateEnquiry);
          this.router.navigateByUrl(redirectUrl);
        }
        // if (response['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          // this.appService.setRateLookupResult(response);
        // } else {
        //   this.appService.setRateLookupResult(response);
        //   console.log(response['data'].transmissionNumber);
        // }
      }
    }, err => {
      this.isLoading = false;
      this.normalView();

      let modal = new Modal({
        action: false, name: modalDetails['name'], title: modalDetails['title'], description: err.message, actionButtonText: ''
      });
      this.modalService.createModalBox(modal, err.status);
    });

  }

  redirectTo(name){
    this.navToIndexEmitter.emit(name);
    // else{
    //   this._snackBar.openFromComponent(SnackBarComponent, { duration: 2000, data: { orderId: '', message: 'Invalid redirect url. Failed to redierct to \''+ redirectUrl + '\'.'} });
    // }
  }

  toggleActionDrop(){
    this.ellipseBtn.showDrop = !this.ellipseBtn.showDrop;
  }

  ellipseAction(action){
    let data;
    if(this.orderDetails?.value?.['stepOne']){
     data = this.orderDetails.value['stepOne'][0];
    } else if(this.configData?.payloadFormat == "DYNAMIC_ACCORDION") {
      let businessObjectId = this.orderDetails.data.businessObject.businessObjectId;
      let businessObjectNumber = this.orderDetails.data.businessObject.businessObjectNumber;
      let orderData = this.formService.formatOrderObject(this.frmGroup.controls);
      let formatData = this.formService.formatDynamicAccordion(orderData);
      data = { businessObjectId, businessObjectNumber, ...formatData };
    } else {
      data = this.orderDetails.value;
    }

    let eventData: any = {
      action: action.type,
      name: this.configData.name,
      component: this,
      configData: action,
      data: data
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  //BOL download function view
  bolDownloadFile = () => {
    let downloadAPI;
    let orderId = this.route.snapshot.params.id;
    this.isLoading = true;
    document.getElementById("overlay").style.display = "block";
    if(this.configData?.header?.action?.details[1]?.command?.downloadBolUrl){
      downloadAPI = `${this.configData?.header?.action?.details[1]?.command?.downloadBolUrl}VIEW_SCORE_EDOC_DOC&orderId=${orderId}&customerCode=${localStorage.getItem('customerCode')}&userId=${localStorage.getItem('userName')}`;
    }else{ 
      downloadAPI = `${APP_Constants.BOL_DOWNLOAD_FILE}VIEW_SCORE_EDOC_DOC&orderId=${orderId}&customerCode=${localStorage.getItem('customerCode')}&userId=${localStorage.getItem('userName')}`;
    }
    this.appService.makeHttpDocRequest(downloadAPI).subscribe({
      next: (data: any) => {
        let fileName = "BOL_Data_";
        fileName += this.appService.getCurrentDateAndTime() + ".pdf";
        let file = new Blob([data], { type: 'application/json' });
        try {
          console.log(data.text() == undefined);
          data.text().then(value => { //convert blob to Json again and check the message.
            let objData = JSON.parse(value)
            if (objData["message"]["statusCode"] == "ERROR") {
              let modal = new Modal({
                action: false, name: 'orderCancelInvalid', title: 'Download File', description: objData["message"]['statusMessage'], actionButtonText: ''
              });
              this.modalService.createModalBox(modal, 'ERROR');
            } else {
              FileSaver.saveAs(data, fileName);//Download here because data is coming in PDF format 
            }
          }).catch(error => {
            FileSaver.saveAs(data, fileName); //Download here because data is coming in PDF format 
          });
        }
        catch (error) {
          console.log(error, "***Connect with TOP BE team***");
        }
        this.normalView();
        this.isLoading = false;
      },
      error: (err) => {
        this.normalView();
        this.isLoading = false;
        try {
          err.error.text().then(value => {
            let objData = JSON.parse(value)
            const message = objData['message']['statusMessage'];
            console.log(message, "****BOL Download Error****")
            let modal = new Modal({
              action: false, name: 'orderCancelInvalid', title: 'Download Failed', description: message, actionButtonText: ''
            });
            this.modalService.createModalBox(modal, 'ERROR');
          })
        }
        catch (error) {
          console.log(error, "***Connect with TOP BE team***");
        }

      }
    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.enableFinalStepAction$) this.enableFinalStepAction$.unsubscribe();
    this.appService.updateEnableFinalStepAction(false);
  }

  //START: CP-3525 - Ability to save the order/s during the verification process
  saveForm(event, command,name) {
    // if(this.configData.header && this.configData.header.action && this.configData.header.action.handler === 'parent'){
      // this.isLoading = false;
    if(this.frmGroup.invalid) {
      return false;
    } else {
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        name: this.configData.name,
        action : 'SUBMIT',
        postData: this.formService.formatOrderObject(this.frmGroup.controls),
        command: command
      })
    }
    // }
  }

   // CP-5734 check banner is open or closed
  getBannerDetail(){
    if((document.getElementById("bannerId") && document.getElementById("bannerId").style.display === 'block')){
      if(localStorage.getItem('templateName') === 'rateEnquirySearch'){
        return 'banner-indicator-height-ratelookup';
      }
      if(localStorage.getItem('templateName') === 'orderEntry'){
        return 'banner-indicator-height-createOrder';}
      if(document.getElementById("genericErrorMessageID")){
        return 'indicator-height';
      } else {
        return 'banner-indicator-height';
      }
    } else {
      if(localStorage.getItem('templateName') === 'rateEnquirySearch'){
        return 'banner-indicator-height-ratelookup';
      }if(localStorage.getItem('templateName') === 'orderEntry'){
        return 'indicator-height-createOrder';}
      return 'indicator-height';
    }
  }

  //CP-9480-start accordian open/close
  toggleAccordian(group,event) {
    group.isActive = !group.isActive;
  }

  checkEllipsisAccess(ellipse) {
    let hiddenCount  = 0;
    ellipse?.forEach((optionBtn) => {
      let flag;
      if(optionBtn?.userAccess) {
        flag = this.checkButtonAccess(optionBtn);
      } 
      if(flag == false) {
        optionBtn.hidden = true;
        hiddenCount ++;
      }
    })
    if(ellipse.length === hiddenCount ) this.isEllipsisHidden = true;
  }
  
  checkButtonAccess(data) {
    const accessList = data?.userAccess;
    let isVisible = false;

    if (data?.buttonVisibilityByTask) {
      const selectedAction =
        this.frmGroup?.get(data?.buttonVisibilityByTask)?.value?.value;
      // Reset always visible
      if (data?.name === 'reset') {
        data.visibility = true;
        return true;
      } else {
        // Show only matching button
        let val = (data?.name === selectedAction) ? true : false;
        data.visibility = val;
        return val;
      }
    }

    if (!Array.isArray(accessList) || accessList.length === 0) {
      data.visibility = true;
      return true;
    }
  
    const currentUserRole = localStorage.getItem('userRole');
    const currentStatus = localStorage.getItem('gskrdOrderStatus');
    const currentUser = localStorage.getItem('userName');
    const userRoles = Array.isArray(currentUserRole) ? currentUserRole : [currentUserRole];
 
    let isAccessEvaluated = false;
  
    for (const row of accessList) {
      const allowedRoles = row?.userRole || [];
      const allowedStatuses = row?.userStatus || [];
  
      const roleMatch = userRoles.some(role => allowedRoles.includes(role));
  
      if (roleMatch) {
        isAccessEvaluated = true;

        if (row?.permittedEditors?.length > 0 && !this.alphaService.isUserCreatorOrRequestor(row, this.frmGroup, currentUser)) {
          isVisible = false;
          break;
        }

        const statusMatch = allowedStatuses.includes(currentStatus);
  
        if (statusMatch) {
          isVisible = true;
          break;
        } else if (row.action === "hidden") {
          isVisible = false;
          break;
        }
      }
    }
  
    if (!isAccessEvaluated) {
      isVisible = false;
    }
  
    data.visibility = isVisible;
    return isVisible;
  }

  sendViewResponseToBackend(orderData){
    const lineItems = orderData?.orderDetailsStepThree?.LineItem;
    if (lineItems) {
      lineItems.forEach(item => {
        const controlSubstances = [];
        for (const key in item) {
          if (key.startsWith("controlSubstance_")) {
            controlSubstances.push(item[key]);
          }
        }
        item.controlSubstanceArray = controlSubstances
        for (const key in item) {
          if (key.startsWith("controlSubstance_") || key === "controlSubstance") {
            delete item[key];
          }
        }
      });
    }
  }

  getSubHeaderInfo(orderData) {
    const businessObject = orderData?.data?.businessObject;
    const configSubHeader = this.configData?.header?.subHeaderInfo;
    const payloadFormat = this.configData?.payloadFormat;

    if (businessObject) {
      this.subHearderInfo = businessObject;
      const status = businessObject.status;
      const excludedKeys = ['trackingLink','shipmentIdentifier'];

      this.infoFieldsToDisplay = configSubHeader?.shipmentDetails?.filter(f => !excludedKeys.includes(f.key)) || [];
      this.trackingLinkField = configSubHeader?.shipmentDetails?.find(f => f.key === 'trackingLink');

      this.isSubHeaderVisible = payloadFormat === 'DYNAMIC_ACCORDION';

      switch (status) {
        case APP_Constants.SENT_TO_TMS:
          this.setBadgeInfo(status, 'STM', 'dhl-ST-gsk');
          break;
        case APP_Constants.CANCELLED:
          this.setBadgeInfo(status, 'C', 'dhl-C-gsk');
          break;
        case APP_Constants.SENT_FOR_VERIFICATION:
          this.setBadgeInfo(status, 'SV', 'dhl-SV-gsk');
          break;
        case APP_Constants.VERIFICATION_FAILED:
          this.setBadgeInfo(status, 'VF', 'dhl-VF-gsk');
          break;
        case APP_Constants.REJECTED_IN_TMS:
          this.setBadgeInfo(status, 'RTM', 'dhl-RTM-gsk');
          break;
        case APP_Constants.SENT_TO_TMS_FAILED:
          this.setBadgeInfo(status, 'STF', 'dhl-STF-gsk');
          break;
      }
    }
  }

  setBadgeInfo(status: string, text: string, className: string) {
    this.badgeStatus = status;
    this.badgeText = text;
    this.badgeClassName = className;
  }

  isVisible(field: any, status: string): boolean {
    return Array.isArray(field?.visibleForStatuses) && field.visibleForStatuses.includes(status);
  }
    
  getDisplayStyle(data) {
    return this.checkButtonAccess(data) ? 'inline-block' : 'none !important';
  }
}
